// Custom script for mobile menu dropdown on navigation.liquid
function openCurrencyDropdown() {
	document.getElementById("myDropdown").classList.toggle("show");
  }
  
  // Close the dropdown if the user clicks outside of it
  window.onclick = function(event) {
	if (!event.target.matches('.dropbtn-currency')) {
	  var dropdowns = document.getElementsByClassName("currency-dropdown-content");
	  var i;
	  for (i = 0; i < dropdowns.length; i++) {
		var openDropdown = dropdowns[i];
		if (openDropdown.classList.contains('show')) {
		  openDropdown.classList.remove('show');
		}
	  }
	}
  }
  function openAssistanceDropdown() {
	document.getElementById("myDropdownTwo").classList.toggle("show");
  }
  
  // Close the dropdown if the user clicks outside of it
  window.onclick = function(event) {
	if (!event.target.matches('.dropbtn-assistance')) {
	  var dropdowns = document.getElementsByClassName("assistance-dropdown-content");
	  var i;
	  for (i = 0; i < dropdowns.length; i++) {
		var openDropdown = dropdowns[i];
		if (openDropdown.classList.contains('show')) {
		  openDropdown.classList.remove('show');
		}
	  }
	}
  }
  
  // Currency selector logic
  
  function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });

  // Calculate the progress number, and the width of the progress bar. Compiled to ES5.
function calculateProgress(currentVal, targetVal) {
    var progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
    var progressNum = document.querySelectorAll('.cart-shipping__num');
    var progressOuter = document.querySelectorAll('.cart-shipping__numOuter');
    var successMsg = document.querySelectorAll('.cart-shipping__success');
    // calculate how far progress is from the total as a percentage
    var result = Math.round(100 * currentVal / targetVal);
    progressBar.forEach(function(el){
      el.setAttribute('style', "width: ".concat(result, "%"));
    })
     // Update the progess text. If threshold is met, show success message
    var newProgressNum = ((targetVal - currentVal) / 100).toFixed(2);
    if(newProgressNum <= 0){
      successMsg.forEach(function(el){
        el.setAttribute('style', 'display: block;');
      });
      progressOuter.forEach(function(el){
        el.setAttribute('style', 'display: none;');
      });
      progressNum.forEach(function(el){
        el.textContent = newProgressNum;
      });
    } else {
      successMsg.forEach(function(el){
        el.setAttribute('style', 'display: none;');
      });
      progressOuter.forEach(function(el){
        el.setAttribute('style', 'display: block;');
      });
      progressNum.forEach(function(el){
        el.textContent = newProgressNum;
      });
    }
  };

// Find each ajax call where your store adds to, deletes from, and updates the cart. Put this in the success function of each. 
// NOTE: If this ajax request outside of the functions that update the cart, the calculator won't sync with the current cart state without refreshing the page. You need to specify that you want to read the current cart data AFTER the new items are added/removed.
  $.ajax({
  type: 'GET',
  url: '/cart.js',
  dataType: 'json',
  success: function(cart){
    /* 2026-08-30: threshold scaled by Shopify.currency.rate. cart.total_price is
       PRESENTMENT cents; every free-shipping condition on the store (Canada zones
       and the US zone alike) is TOTAL_PRICE >= 175.00 CAD, so the CAD-175
       equivalent is the correct bar in every market. Kept in step with the
       cart-change meter owner appended at the end of this file — if these two
       disagree, first paint and first update show different numbers. */
    var hvRate = 1;
    try {
      var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
      if (isFinite(r) && r > 0) hvRate = r;
    } catch (e) {}
    calculateProgress(cart.total_price, 17500 * hvRate);
  }
});

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

function detectUserInteraction(){
  document.getElementsByTagName('html')[0].classList.add('js-user-action');

  'keydown mouseover touchmove touchstart wheel'.split(" ").forEach(function(e){
      window.removeEventListener(e,detectUserInteraction,false);
  });
}

if( window.mobileCheck() ){

  'keydown mouseover touchmove touchstart wheel'.split(" ").forEach(function(e){
      window.addEventListener(e,detectUserInteraction,false);
  });
}else{
  document.getElementsByTagName('html')[0].classList.add('js-user-action');
}

/* ============================================================
   Hobbiesville — Quantity-limit & cart-error net v4
   (toast fallback + clamp + Phase B violation UX + theme error
   cleanup + cart recovery)
   v4 (2026-07-07, Noibu issue #51): toast is now the single message
   surface for ALL /cart 422s (sold-out and inventory rejections
   included, using Shopify's own wording); the theme's popover-error is
   hidden for every cart error, not just limit ones; the LIMIT badge
   only flashes for genuine limit rejections; toast radius 4px -> 7px
   to match the Phase B badge/stepper family.
   v4.1 (same day): cart:add-item dispatch guard added — swallows the
   theme's cart:add-item on pages without [data-cart-toggle], where its
   unguarded listener (this.cartToggle.classList) crashes and the icon
   animation has no target anyway. Runtime substitute for patching
   theme.dev.js; remove when a guarded theme.dev.js (or v7) ships.
   v4.2 (same day): sold-out 422s — toast copy softened to "is now
   sold out" (race-honest wording) and the triggering form's Add to
   Cart button flips to the theme's real disabled Sold Out state
   ([data-add-to-cart][disabled] + theme.translations.sold_out), so a
   stale page stops inviting doomed clicks. Theme-owned add forms only;
   StorePass React buttons stay toast-only until Trent's native build.
   Pairs with the "max-per-order" checkout validation
   (Hobbiesville Ops; custom.quantity_max / quantity_min) and the
   Phase B Liquid (limit badges, [data-hv-limit-cap] inputs,
   [data-hv-limit-alert] box, .hv-limit-note cart notes).
   Phase B handlers are inert on themes without those attributes.
   Removable any time: delete this block.
   ============================================================ */
(function () {
  'use strict';
  if (window.__hvQtyNetV2) return; // guard against double-paste
  window.__hvQtyNetV2 = true;

  var CART_MUTATION = /\/cart\/(add|change|update)/;
  var LIMIT_MSG = /(Limit \d+ per customer|Minimum \d+ per order|Only \d+ per customer)/;
  var lastText = '', lastAt = 0, lastQtyEl = null;

  /* --- TEMPORARY limits map for StorePass-rendered surfaces (collection/search
         grids) where Liquid can't reach. handle → max. Kept in sync by the daily
         audit job; the checkout validation remains the wall, so staleness here is
         cosmetic only. REMOVE this block once StorePass ships native limit
         badges/caps on their cards. Snapshot 2026-07-07. --- */
  var HV_LIMITS = {
    'app-exlusive-pokemon-scarlet-and-violet-destined-rivals-booster-box-pre-order': 2,
    'pokemon-tcg-mega-evolution-set-5-pitch-black-elite-trainer-box-pre-order': 1,
    'pokemon-first-partner-illustration-collections-series-3-pre-order': 4,
    'app-exclusive-pokemon-tcg-mega-evolution-set-5-booster-bundle-max-6-pre-order': 4,
    'mtg-universes-beyond-the-hobbit-gift-bundle-pre-order': 2,
    'pokemon-tcg-mega-evolution-set-5-pitch-black-24-sleeved-pack-bundle-pre-order': 2,
    'app-exclusive-pokemon-tcg-mega-evolution-set-5-pitch-black-booster-box-max-2-pre-order': 2,
    'pokemon-tcg-mega-evolution-set-5-pitch-black-3-pack-blister-pre-order': 4,
    'app-exclusive-wave-2-bundle-pokemon-pitch-black-max-1-per-customer-pre-order': 1,
    'pokemon-tcg-moonlit-tin-bundle-1-of-each-variant-pre-order': 3,
    'wave-2-pokemon-tcg-mega-evolution-set-4-chaos-rising-booster-bundle-pre-order': 12,
    'one-piece-cg-op-13-booster-box-carrying-on-his-will-wave-2-pre-order': 1,
    'pokemon-tcg-mega-set-5-booster-box-pre-order': 1,
    'pokemon-tcg-mega-forces-tin-mega-zeraora-ex-pre-order': 2,
    'pokemon-tcg-mega-forces-tin-mega-darkrai-ex-pre-order': 2,
    'pokemon-tcg-mega-forces-tin-mega-dragonite-ex-pre-order': 2,
    'one-piece-cg-illustration-box-vol-10-pre-order': 2,
    'pokemon-ascended-heroes-tin-mega-feraligatr-ex-pre-order': 2,
    'pokemon-ascended-heroes-tin-mega-emboar-ex-pre-order': 2,
    'pokemon-tcg-mega-set-6-delta-reign-booster-bundle-pre-order': 6,
    'pokemon-30th-celebration-espeon-ex-and-umbreon-ex-battle-deck-bundle-pre-order': 6,
    'app-exclusive-wave-2-pokemon-first-partner-illustration-collections-series-2-pre-order': 6
  };

  /* --- styles: toast + shake animation --- */
  var css = document.createElement('style');
  css.textContent =
    '@keyframes hvShake{10%,90%{transform:translateX(-1px)}20%,80%{transform:translateX(2px)}' +
    '30%,50%,70%{transform:translateX(-3px)}40%,60%{transform:translateX(3px)}}' +
    '.hv-limit-shake{animation:hvShake .5s ease both;box-shadow:0 0 0 2px var(---color-error-text,#d02e2e)!important;' +
    'border-radius:7px;transition:box-shadow .3s ease;}' +
    '.hv-limit-violate{animation:hvShake .5s ease both;border-color:var(---color-error-border,#d02e2e)!important;' +
    'color:var(---color-error-text,#d02e2e)!important;transition:border-color .3s ease,color .3s ease;}' +
    '.hv-limit-chip-wrap{width:100%;display:flex;justify-content:center;margin:0 0 5px;}' +
    '.hv-limit-chip{display:inline-flex;align-items:center;margin:0;padding:4px 10px;' +
    'border:1px solid var(---color-border,#000);border-radius:7px;color:var(---color-text,#000);' +
    'font-size:12px;line-height:1.3;font-weight:var(---body-font-weight-bold,700);' +
    'letter-spacing:.04em;text-transform:uppercase;white-space:nowrap;}' +
    '@media (prefers-reduced-motion: reduce){.hv-limit-shake,.hv-limit-violate{animation:none;}}';
  document.head.appendChild(css);

  function toastEl() {
    var el = document.getElementById('hv-qty-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'hv-qty-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.style.cssText =
        'position:fixed;left:50%;bottom:20px;transform:translateX(-50%);' +
        'max-width:92vw;box-sizing:border-box;padding:10px 20px;' +
        'background:#000;color:#fff;border-radius:7px;' +
        'font-size:14px;line-height:1.45;text-align:center;white-space:pre-line;' +
        'box-shadow:0 4px 16px rgba(0,0,0,.35);z-index:2147483000;' +
        'opacity:0;transition:opacity .25s ease;pointer-events:none;';
      (document.body || document.documentElement).appendChild(el);
    }
    return el;
  }

  function showToast(text) {
    var now = Date.now();
    if (text === lastText && now - lastAt < 1500) return;
    lastText = text; lastAt = now;
    var el = toastEl();
    el.textContent = text;
    el.style.opacity = '1';
    clearTimeout(el.__hvT);
    el.__hvT = setTimeout(function () { el.style.opacity = '0'; }, 4000);
  }

  /* ============ Phase B violation UX ============
     The limit badge is the violation surface — PDP badge above the stepper,
     or the cart line's limit chip — it shakes and flashes error-red while
     the stepper keeps its red ring + shake. The theme's misleading
     "No more inventory available" tooltip is stripped for limit caps. */

  function hvHolder(i) { return i.closest('[data-quantity-holder]'); }

  function hvShowViolation(input) {
    if (!input || !input.hasAttribute || !input.hasAttribute('data-hv-limit-cap')) return false;
    var h = hvHolder(input), hit = false;
    /* the limit badge is the violation surface: PDP badge above the stepper,
       or the cart line's limit note — it shakes and flashes error-red */
    var chip = null;
    var form = input.closest('form');
    if (form) chip = form.querySelector('[data-hv-limit-badge]');
    if (!chip) {
      var cell = input.closest('.cart-product__quantity');
      chip = cell && cell.querySelector('.hv-limit-note');
    }
    if (!chip) {
      var card = input.closest('[data-hv-limit-card]');
      chip = card && card.querySelector('.hv-limit-chip');
    }
    /* 2026-09-07: PDP buy box. Its quantity input is NOT a DOM descendant of a <form>
       — it is bound by the form="product-form-…" attribute — so the closest('form')
       lookup above returns null and never finds the Liquid-rendered badge. Measured:
       the shake fired but the badge never flashed.

       [data-hv-limit-scope] is emitted by snippets/buy-buttons.liquid on the wrapper
       holding both the badge and the stepper. It is deliberately a SEPARATE hook from
       data-hv-limit-card: that one opts an element into hvDecorateCards, which would
       overwrite the input's metafield-derived cap with the hardcoded HV_LIMITS value
       (see the guard at the top of hvDecorateCards). Liquid-owned surfaces must keep
       the metafield as their source of truth. */
    if (!chip) {
      var scope = input.closest('[data-hv-limit-scope]');
      chip = scope && scope.querySelector('[data-hv-limit-badge]');
    }
    if (chip) {
      chip.classList.remove('hv-limit-violate');
      void chip.offsetWidth;
      chip.classList.add('hv-limit-violate');
      clearTimeout(chip.__hvT);
      chip.__hvT = setTimeout(function () { chip.classList.remove('hv-limit-violate'); }, 4000);
      hit = true;
    }
    if (h) {
      h.classList.remove('hv-limit-shake');
      void h.offsetWidth;
      h.classList.add('hv-limit-shake');
      setTimeout(function () { h.classList.remove('hv-limit-shake'); }, 1300);
      var plus = h.querySelector('[data-quantity-plus]');
      if (plus) setTimeout(function () {
        plus.removeAttribute('data-quantity-tooltip');
        plus.removeAttribute('data-quantity-tooltip-visible');
        plus.removeAttribute('title');
      }, 0);
    }
    return hit;
  }

  /* + pressed at the wall: value can't change, so catch the click itself.
     Swallow the event entirely (capture phase runs before the theme's
     handlers) — otherwise the theme fires a same-quantity /cart/change.js,
     shows its loading state, then its limit banner: shake→load→shake.
     One clean violation moment instead. */
  function hvTarget(ev) {
    /* shadow DOM retargets events at document level — composedPath keeps
       the real origin (StorePass search renders in a shadow tree) */
    return (ev.composedPath && ev.composedPath()[0]) || ev.target;
  }

  document.addEventListener('click', function (ev) {
    var tgt = hvTarget(ev);
    var plus = tgt && tgt.closest && tgt.closest('[data-quantity-plus]');
    if (plus) {
      var h = plus.closest('[data-quantity-holder]');
      var capped = h && h.querySelector('input[data-hv-limit-cap]');
      if (capped) {
        var mx = parseInt(capped.getAttribute('max'), 10);
        var vl = parseInt(capped.value, 10);
        if (!isNaN(mx) && !isNaN(vl) && vl >= mx) {
          ev.preventDefault();
          ev.stopPropagation();
          hvShowViolation(capped);
          return;
        }
      }
    }
    /* remember the stepper the shopper last touched (toast/shake targeting) */
    var b = tgt && tgt.closest && tgt.closest('button, [data-quantity-plus], [data-quantity-minus]');
    if (!b) return;
    var wrap = b.closest('[data-quantity-holder], .product__quantity, .cart__quantity, form, td, div');
    var input = wrap && wrap.querySelector && wrap.querySelector('input[name="quantity"], input[name="updates[]"], input[type="number"]');
    if (input) lastQtyEl = input;
  }, true);

  /* typed overflow: remember the raw value before the clamp rewrites it */
  document.addEventListener('input', function (ev) {
    var t = hvTarget(ev);
    if (t && t.tagName === 'INPUT' && t.hasAttribute('data-hv-limit-cap')) t.__hvRaw = parseInt(t.value, 10);
  }, true);
  document.addEventListener('change', function (ev) {
    var t = hvTarget(ev);
    if (t && t.tagName === 'INPUT' &&
        (t.type === 'number' || t.name === 'quantity' || t.name === 'updates[]')) lastQtyEl = t;
  }, true);

  function shakeQty() {
    var el = lastQtyEl ||
      document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    if (!el) return;
    var target = el.closest('[data-quantity-holder], .product__quantity') || el;
    target.classList.remove('hv-limit-shake');
    void target.offsetWidth; // restart animation
    target.classList.add('hv-limit-shake');
    setTimeout(function () { target.classList.remove('hv-limit-shake'); }, 1300);
  }

  /* --- TEMPORARY: decorate StorePass-rendered product cards (collection/search
         grids) with a LIMIT chip and tag their inputs, so limited products are
         visible before rejection and hvShowViolation has a surface to flash.
         React owns those steppers, so no hard cap here — the checkout validation
         is the wall. Self-healing via the MutationObserver (re-inserts after
         React re-renders). Remove with HV_LIMITS at StorePass handoff. --- */
  var hvDecorateT = 0;
  function hvDeepLinks() {
    /* product links in the document AND inside any open shadow roots
       (StorePass search results render in a shadow tree) */
    var out = [];
    function collect(root) {
      var found = root.querySelectorAll('a[href*="/products/"]');
      for (var i = 0; i < found.length; i++) out.push(found[i]);
    }
    collect(document);
    try {
      var walker = document.createTreeWalker(document.documentElement, NodeFilter.SHOW_ELEMENT);
      var n;
      while ((n = walker.nextNode())) {
        if (n.shadowRoot) collect(n.shadowRoot);
      }
    } catch (e) { /* older browsers: document-level links already collected */ }
    return out;
  }
  /* 2026-09-04: StorePass's own rule is "price $0 -> Contact Us" regardless of
     stock, and it still paints the OUT OF STOCK pill. The store rule is
     "$0 AND Warehouse stock -> Contact Us; $0 without -> Notify Me" (the PDP
     does this in Liquid). Align the grid: a Contact Us card that carries the
     out-of-stock pill becomes a grey Notify Me (pill stays); one without the
     pill keeps Contact Us and loses the $0.00 price. Re-runs on every StorePass
     re-render via the existing decorator observer. Spec for Trent to own this
     server-side is in the StorePass notes. */
  function hvContactCards() {
    var ctas = document.querySelectorAll('.store-pass-product-cta, button, a');
    for (var i = 0; i < ctas.length; i++) {
      var c = ctas[i];
      if (c.hasAttribute('data-hv-contact-card')) continue;
      var label = (c.textContent || '').trim().toLowerCase();
      if (label !== 'contact us') continue;
      /* 2026-09-09: STOREPASS CARDS ONLY. Our own rails render a Contact Us
         button too, so they matched this scan, and the [class*="price"] sweep
         below then set display:none on .hv-rail__price-container — collapsing
         the card by one line and lifting its stepper and CTA above every other
         card in the rail (measured on /cart: CTA top 1637 vs 1662). Our cards
         compute st.contact themselves and reserve the row, so they need none of
         this repair. Skip anything inside one of ours. */
      if (c.closest && c.closest('.hv-rail__card, [data-hv-rail], .hv-continue, .hv-cp, [data-hv-bd-side], [data-hv-bd-item]')) continue;
      var card = c, d = 0;
      while (card && d < 8 && !(card.querySelector && card.querySelector('a[href*="/products/"]') && card.querySelector('img'))) { card = card.parentElement; d++; }
      c.setAttribute('data-hv-contact-card', '1');
      if (!card) continue;
      /* rule: $0 = Contact Us regardless of stock -> the OUT OF STOCK pill is wrong here */
      var badges = card.querySelectorAll('.store-pass-badge, [class*="badge"]');
      for (var b = 0; b < badges.length; b++) {
        if (/out of stock|sold out/i.test(badges[b].textContent || '')) badges[b].style.display = 'none';
      }
      var prices = card.querySelectorAll('[class*="price"]');
      for (var p = 0; p < prices.length; p++) {
        if (/^\$?0([.,]00)?$/.test((prices[p].textContent || '').replace(/[\s]|CAD|USD/g, ''))) prices[p].style.display = 'none';
      }
    }
  }
  function hvDecorateCards() {
    var now = Date.now();
    if (now - hvDecorateT < 300) return;
    hvDecorateT = now;
    try { hvContactCards(); } catch (e) {}
    var links = hvDeepLinks();
    for (var i = 0; i < links.length; i++) {
      var m = /\/products\/([a-z0-9\-]+)/.exec(links[i].getAttribute('href') || '');
      var lim = m && HV_LIMITS[m[1]];
      if (!lim) continue;
      /* climb to the card: nearest ancestor that also contains a number input */
      var node = links[i], card = null, depth = 0;
      while (node && depth < 7) {
        node = node.parentElement; depth++;
        if (node && node.querySelector && node.querySelector('input[type="number"]')) { card = node; break; }
      }
      if (!card) continue;
      /* grid-level false positive guard: a card links to exactly one product */
      var hrefs = {};
      var cardLinks = card.querySelectorAll('a[href*="/products/"]');
      for (var j = 0; j < cardLinks.length; j++) {
        var mm = /\/products\/([a-z0-9\-]+)/.exec(cardLinks[j].getAttribute('href') || '');
        if (mm) hrefs[mm[1]] = true;
      }
      if (Object.keys(hrefs).length !== 1) continue;
      var input = card.querySelector('input[type="number"]');
      if (!input) continue;
      /* Liquid-owned surfaces (PDP buy box, cart lines) render their own
         badge/note below or above the stepper — never double-chip them.
         Decorator-processed cards carry data-hv-limit-card and stay
         eligible so the chip self-heals after React re-renders. */
      if (input.hasAttribute('data-hv-limit-cap') && !card.hasAttribute('data-hv-limit-card')) continue;
      card.setAttribute('data-hv-limit-card', m[1]);
      input.setAttribute('data-hv-limit-cap', lim);
      if (!card.querySelector('.hv-limit-chip')) {
        var wrap = document.createElement('div');
        wrap.className = 'hv-limit-chip-wrap';
        var chipEl = document.createElement('span');
        chipEl.className = 'hv-limit-chip';
        chipEl.textContent = 'Limit ' + lim + ' per customer';
        wrap.appendChild(chipEl);
        var row = input.parentElement || input;
        if (row.parentElement) row.parentElement.insertBefore(wrap, row);
      }
    }
  }
  hvDecorateCards();

  /* --- theme error cleanup: duplicated pink popover (PDP) and the
         "No more products available for purchase" cart banner, which is
         inaccurate for per-customer caps — the line chip owns that message --- */
  var mo = new MutationObserver(function () {
    hvDecorateCards();
    document.querySelectorAll('.popover-error').forEach(function (p) {
      /* v4: the toast owns cart-error messaging on every surface — the
         header popover is invisible on mobile (~4 in 5 of these errors)
         and would double-message on desktop, so hide it for every cart
         error. Targets the transient .popover-error node itself, so the
         container still shows later success popovers. */
      var holder = p.closest('[class*="popover"]') || p;
      holder.style.display = 'none';
    });
    document.querySelectorAll('[data-cart-errors]').forEach(function (banner) {
      var msg = banner.querySelector('[data-error-message]');
      var title = msg && msg.textContent.trim();
      if (!title) return;
      var inputs = document.querySelectorAll('input[data-hv-limit-cap]');
      for (var k = 0; k < inputs.length; k++) {
        var row = inputs[k].closest('[data-item]');
        var t = row && row.querySelector('.cart-product__title');
        if (t && t.textContent.trim() === title) {
          banner.style.display = 'none';
          msg.textContent = '';
          hvShowViolation(inputs[k]);
          return;
        }
      }
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

  function collectMessages(j) {
    var out = [];
    function push(v) {
      if (typeof v === 'string' && v.trim() && out.indexOf(v.trim()) === -1) out.push(v.trim());
    }
    if (!j || typeof j !== 'object') return out;
    push(j.description);
    if (j.message && j.message !== 'Cart Error') push(j.message);
    var e = j.errors;
    if (typeof e === 'string') push(e);
    else if (Array.isArray(e)) e.forEach(push);
    else if (e && typeof e === 'object') {
      Object.keys(e).forEach(function (k) {
        var v = e[k];
        if (Array.isArray(v)) { v.forEach(push); } else { push(v); }
      });
    }
    return out;
  }

  var SOLD_OUT_MSG = /is already sold out/;

  /* sold-out 422: the page just proved itself stale — flip the add
     button that produced the click into the theme's genuine Sold Out
     state (same attributes Liquid renders server-side) so it stops
     inviting more clicks. Conservative scope: only the add-to-cart
     form the shopper touched, else the main PDP form. React-owned
     (StorePass) buttons are left alone — React would clobber the
     mutation on re-render; their fix lands with the native build. */
  function hvMarkSoldOut() {
    try {
      var scope = (lastQtyEl && lastQtyEl.closest && lastQtyEl.closest('form[action*="/cart/add"]')) ||
        (/^\/products\//.test(location.pathname) && document.querySelector('form[action*="/cart/add"]'));
      if (!scope) return;
      var btn = scope.querySelector('[data-add-to-cart]') || scope.querySelector('button[name="add"]');
      if (!btn) return;
      btn.setAttribute('disabled', 'disabled');
      var label = (window.theme && theme.translations && theme.translations.sold_out) || 'Sold Out';
      var txt = btn.querySelector('[data-add-to-cart-text]') || btn;
      txt.textContent = label;
    } catch (e) { /* cosmetic only — never break the toast */ }
  }

  function handleBlocked(json, kind) {
    try {
      var msgs = collectMessages(json);
      var isLimit = LIMIT_MSG.test(msgs.join('\n'));
      if (SOLD_OUT_MSG.test(msgs.join('\n'))) {
        msgs = msgs.map(function (m) { return m.replace(/is already sold out/g, 'is now sold out'); });
        hvMarkSoldOut();
      }
      /* v4: route by rejection type. Limit rejections -> the Phase B
         badge/chip is the violation surface (toast only if that surface is
         missing). Inventory rejections (sold out / all remaining stock
         already in cart) -> toast with Shopify's own wording; never flash
         the LIMIT badge for a stock problem. */
      if (!(isLimit && hvShowViolation(lastQtyEl))) {
        showToast(msgs.length ? msgs.slice(0, 3).join('\n')
                              : 'Couldn’t add to cart — item unavailable.');
        shakeQty();
      }
      // Cart page: the theme's change handler has no error path and leaves
      // the row spinning — resync after the shopper has seen the message.
      if (kind !== 'add' && /^\/cart\/?$/.test(location.pathname)) {
        setTimeout(function () { location.reload(); }, 1600);
      }
    } catch (e) { /* never break the page */ }
  }

  function kindFromUrl(url) {
    var m = /\/cart\/(add|change|update)/.exec(url || '');
    return m ? m[1] : '';
  }

  /* --- fetch interceptor (theme + StorePass) --- */
  if (window.fetch) {
    var hvFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '', method = 'GET';
      try {
        url = (input && input.url) ? input.url : String(input || '');
        method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      } catch (e) {}
      var p = hvFetch.apply(this, arguments);
      if (method === 'POST' && CART_MUTATION.test(url)) {
        p.then(function (res) {
          if (res && res.status === 422) {
            res.clone().json().then(function (j) { handleBlocked(j, kindFromUrl(url)); })
              .catch(function () { handleBlocked(null, kindFromUrl(url)); });
          }
        }).catch(function () {});
      }
      return p;
    };
  }

  /* --- XHR interceptor (jQuery $.ajax cart calls) --- */
  if (window.XMLHttpRequest) {
    var hvOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        this.__hvCartKind = (String(method || '').toUpperCase() === 'POST')
          ? kindFromUrl(String(url || '')) : '';
      } catch (e) { this.__hvCartKind = ''; }
      return hvOpen.apply(this, arguments);
    };
    var hvSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__hvCartKind) {
        var kind = this.__hvCartKind;
        this.addEventListener('load', function () {
          if (this.status === 422) {
            var j = null;
            try { j = JSON.parse(this.responseText); } catch (e) {}
            handleBlocked(j, kind);
          }
        });
      }
      return hvSend.apply(this, arguments);
    };
  }

  /* --- cart:add-item dispatch guard: the theme's listener does
         this.cartToggle.classList.add(...) unguarded and crashes on pages
         without [data-cart-toggle] (Noibu: “null is not an object
         (evaluating this.carttoggle.classlist)”, co-timed with every add
         click). The listener only animates that toggle, so on toggle-less
         pages the event has no work to do — swallow it there. Same
         interceptor pattern as the fetch/XHR nets above. Element-level
         dispatches are untouched (override sits on document only). --- */
  var hvDispatch = document.dispatchEvent.bind(document);
  document.dispatchEvent = function (ev) {
    try {
      if (ev && ev.type === 'cart:add-item' && !document.querySelector('[data-cart-toggle]')) {
        return true; /* uncancelled no-op; theme treats dispatch as fire-and-forget */
      }
    } catch (e) { /* fall through to real dispatch */ }
    return hvDispatch(ev);
  };

  /* --- stepper clamp: typed values above max snap back; capped inputs get
         the full violation moment, everything else gets the plain shake --- */
  document.addEventListener('change', function (ev) {
    var t = hvTarget(ev);
    if (!t || t.tagName !== 'INPUT') return;
    var isQty = t.type === 'number' || t.name === 'quantity' || t.name === 'updates[]';
    if (!isQty || !t.hasAttribute('max')) return;
    var max = parseInt(t.getAttribute('max'), 10);
    var min = parseInt(t.getAttribute('min'), 10);
    var val = parseInt(t.value, 10);
    var raw = t.__hvRaw; t.__hvRaw = null;
    if (isNaN(val)) return;
    if (!isNaN(max) && (val > max || (!isNaN(raw) && raw > max))) {
      if (val > max) t.value = max;
      if (!hvShowViolation(t)) shakeQty();
    }
    else if (!isNaN(min) && val < min) { t.value = min; }
  }, true);
})();

/* ============================================================
   Hobbiesville — Add-to-cart confirmation popover (Cowork, 2026-07-08) [v3]
   Shows a compact "Added to your cart" popover under the cart icon on
   EVERY user add — theme product pages AND StorePass grids/search — on
   mobile and desktop. Browser-verified on the staged theme.
   WHY a custom element instead of the theme's native popover: the theme
   popover (a) is gated to viewports >= theme.sizes.mobile (550px) so it
   never fired on phones, (b) is never called by StorePass's own React
   add-to-cart (most of the catalog), and (c) gets hidden by a follow-up
   /cart/update (Order Protect) right after add. Rather than fight all
   three, we hide the theme popover and render our own decoupled element,
   populated from the /cart/add.js response.
   Non-invasive: only reads a CLONE of the cart response — never blocks
   or alters the add (can't slow it down or break it). Only fires after a
   real user click on an add-to-cart control (skips programmatic adds).
   Styling consumes the theme's own tokens (---body-font-family = DIN Next,
   ---color-* ) so it matches the live design automatically.
   Success-path only — 422 cart errors stay owned by the toast net above.
   Supersedes the theme-popover-enable approach. v7: replace with a
   StorePass-native "added to cart" event, or fix in the theme source.
   v4.5 (2026-07-10): tap feedback — tapping the popover paints a pressed
   state (.hv-tapped) in the same frame, then navigates to /cart one frame
   later (rAF + setTimeout defer), so the tap acknowledges instantly
   instead of hanging until unload. Clears the Noibu INP entries
   (#hv-cart-popover 600ms on /search, .hvp-row 1.38s on PDP). Also adds
   a cheap :active acknowledgment for the theme header account link
   (.nav-user__link, the 1.95s / 24-interaction entry) - CSS only,
   navigation untouched.
   Removable any time: delete this block (restores theme-native popover).
   ============================================================ */
(function () {
  'use strict';
  if (window.__hvCartPopover) return;
  window.__hvCartPopover = true;

  var CHECK = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>';

  var st = document.createElement('style');
  st.textContent =
    '.header-cartPopover{display:none !important;}' +
    '#hv-cart-popover{position:fixed;z-index:2147483000;width:196px;box-sizing:border-box;background:var(---color-background,#fff);border:1px solid var(---color-border,#000);padding:11px 14px;opacity:0;transform:translateY(-6px);transition:opacity .28s ease,transform .28s ease;pointer-events:none;font-family:var(---body-font-family),sans-serif;}' +
    '#hv-cart-popover.hv-in{opacity:1;transform:translateY(0);pointer-events:auto;cursor:pointer;}' +
    '#hv-cart-popover.hv-tapped{opacity:.5;transition:opacity .12s ease;}' +
    '.nav-user__link:active{opacity:.55;}' +
    '#hv-cart-popover .hvp-head{display:flex;align-items:center;justify-content:center;gap:5px;font-weight:var(---body-font-weight-bold,700);font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:var(---color-text,#000);padding-bottom:9px;margin-bottom:9px;border-bottom:1px solid var(---color-border-alpha-8,rgba(0,0,0,.1));}' +
    '#hv-cart-popover .hvp-row{display:flex;align-items:center;gap:11px;}' +
    '#hv-cart-popover .hvp-thumb{flex:0 0 46px;width:46px;height:46px;border:1px solid rgba(0,0,0,.08);background-size:contain;background-repeat:no-repeat;background-position:center;background-color:#f4f2ec;}' +
    '#hv-cart-popover .hvp-info{flex:1 1 0;min-width:0;}' +
    '#hv-cart-popover .hvp-title{font-weight:var(---body-font-weight-bold,700);font-size:13px;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(---color-text,#000);}' +
    '#hv-cart-popover .hvp-variant{font-size:11px;opacity:.55;margin-top:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(---color-text,#000);}' +
    '#hv-cart-popover .hvp-price{font-weight:900;font-size:13px;margin-top:3px;color:var(---color-text,#000);}' +
    '@media (prefers-reduced-motion:reduce){#hv-cart-popover{transition:opacity .28s ease;transform:none;}#hv-cart-popover.hv-in{transform:none;}}';
  (document.head || document.documentElement).appendChild(st);

  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function money(c){return c==null?'':'$'+(c/100).toFixed(2);}

  var el;
  function ensure(){
    if(!el||!document.body.contains(el)){
      el=document.createElement('div');
      el.id='hv-cart-popover';
      el.setAttribute('role','status');
      el.setAttribute('aria-live','polite');
      el.addEventListener('click',function(){
        if(el.__hvNav) return;                 /* double-tap guard */
        el.__hvNav=true;
        el.classList.add('hv-tapped');         /* instant visual ack - paints this frame */
        requestAnimationFrame(function(){ setTimeout(function(){ window.location.href='/cart'; }, 0); });
      });
      document.body.appendChild(el);
    }
    return el;
  }
  function cartIconRect(){
    var best=null;
    document.querySelectorAll('.js-cartToggle,.cartToggle,[data-cart-toggle],a[href="/cart"]').forEach(function(x){
      var r=x.getBoundingClientRect();
      if(r.width>0&&r.height>0&&r.top<200){ if(!best||r.right>best.right) best=r; }
    });
    return best;
  }
  function anchor(n){
    var r=cartIconRect();
    n.style.left='auto'; n.style.bottom='auto';
    if(r){ n.style.top=Math.round(r.bottom+8)+'px'; n.style.right=Math.max(8,Math.round(window.innerWidth-r.right))+'px'; }
    else { n.style.top='58px'; n.style.right='12px'; }
  }
  function show(item){
    if(!item) return;
    var n=ensure();
    n.__hvNav=false;
    n.classList.remove('hv-tapped');
    var img=item.image||(item.featured_image&&item.featured_image.url)||'';
    var title=item.product_title||item.title||'';
    var variant=(item.variant_title&&item.variant_title!==null&&item.variant_title!=='null')?item.variant_title:'';
    var price=money(item.final_price!=null?item.final_price:item.price);
    n.innerHTML='<div class="hvp-head"><span style="display:inline-flex;color:var(---color-text,#000)">'+CHECK+'</span>Added to your cart</div>'+
      '<div class="hvp-row"><div class="hvp-thumb"'+(img?' style="background-image:url('+esc(img)+')"':'')+'></div>'+
      '<div class="hvp-info"><div class="hvp-title">'+esc(title)+'</div>'+
      (variant?'<div class="hvp-variant">'+esc(variant)+'</div>':'')+
      '<div class="hvp-price">'+price+'</div></div></div>';
    anchor(n);
    void n.offsetWidth;
    n.classList.add('hv-in');
    clearTimeout(n.__t);
    n.__t=setTimeout(function(){ n.classList.remove('hv-in'); }, 4000);
  }

  var pend=0;
  document.addEventListener('click',function(ev){
    var path=(ev.composedPath&&ev.composedPath())||[ev.target];
    for(var i=0;i<path.length;i++){
      var x=path[i]; if(!x||x.nodeType!==1) continue;
      var cn=(typeof x.className==='string')?x.className:'';
      if((x.classList&&(x.classList.contains('store-pass-product-cta')||x.classList.contains('product__form-submit')))||cn.indexOf('store-pass-product-cta')>=0){ pend=Date.now(); return; }
      if(x.matches&&x.matches('[data-add-to-cart],[name="add"],form[action*="/cart/add"] button,form[action*="/cart/add"] [type="submit"]')){ pend=Date.now(); return; }
    }
  },true);

  function onAdd(json){
    if(Date.now()-pend>6000) return;
    pend=0;
    var it=json&&(json.items?json.items[json.items.length-1]:json);
    if(it&&(it.product_title||it.title)){ try{ show(it); }catch(e){} }
  }

  if(window.fetch){
    var of=window.fetch;
    window.fetch=function(i,init){
      var u=(i&&i.url)?i.url:String(i||'');
      var m=((init&&init.method)||(i&&i.method)||'GET').toUpperCase();
      var p=of.apply(this,arguments);
      if(m==='POST'&&/\/cart\/add/.test(u)){
        p.then(function(r){ if(r&&r.status>=200&&r.status<300){ r.clone().json().then(onAdd).catch(function(){}); } }).catch(function(){});
      }
      return p;
    };
  }
  if(window.XMLHttpRequest){
    var oo=XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open=function(m,u){ try{ this.__hvAdd=(String(m||'').toUpperCase()==='POST'&&/\/cart\/add/.test(String(u||''))); }catch(e){} return oo.apply(this,arguments); };
    var os=XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send=function(){
      if(this.__hvAdd){ this.addEventListener('load',function(){ if(this.status>=200&&this.status<300){ var j=null; try{ j=JSON.parse(this.responseText); }catch(e){} if(j) onAdd(j); } }); }
      return os.apply(this,arguments);
    };
  }
}());
/* =============================================================
   HV CART COUNT OWNER — v7 rebuild (Aug 28 2026)
   custom.js is the SOLE owner of the header cart badge.

   Every element carrying [data-cart-toggle-count] is written from
   the authoritative /cart.js item_count after ANY cart mutation
   (theme add, StorePass add, popover, quick-add, cart page),
   on first paint, and on bfcache restore.

   StorePass (storepass.js) bumps #CartToggleItemCount and
   #CartToggleItemCountMobile by id and by innerText arithmetic.
   Those ids are no longer emitted by sections/header.liquid, so
   its writes (null-guarded, verified in the live 550,192 B build)
   are inert no-ops. DO NOT re-introduce those ids.
   ============================================================= */
(function () {
  if (window.__hvCartCountOwner) return;
  window.__hvCartCountOwner = true;

  /* ---- claim the badge ----
     Strip the two ids storepass.js writes by id. Its writes are
     null-guarded, so once the ids are gone they are inert and the
     optimistic +1 can never disagree with the server (quantity
     limits clamp adds; an optimistic bump would flash a wrong
     number). Verified on staging 156172779658: 0 CSS rules and 0
     theme scripts reference these ids. Ported code MUST use
     [data-cart-toggle-count]. */
  function claim() {
    ['CartToggleItemCount', 'CartToggleItemCountMobile'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.hasAttribute('data-cart-toggle-count')) el.removeAttribute('id');
    });
  }

  var BADGE = '[data-cart-toggle-count]';
  var MUTATORS = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var timer = null;
  var inFlight = false;

  function paint(count) {
    var n = Number(count);
    if (!isFinite(n) || n < 0) return;
    var nodes = document.querySelectorAll(BADGE);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.textContent.trim() !== String(n)) el.textContent = n;
      var host = el.closest ? (el.closest('.cartToggle') || el.closest('.js-cartToggle')) : null;
      if (host && host.classList) host.classList.toggle('cartToggle--empty', n === 0);
    }
    document.documentElement.setAttribute('data-hv-cart-count', n);
    try {
      document.dispatchEvent(new CustomEvent('hv:cart-count', { detail: { count: n } }));
    } catch (e) {}
  }

  function sync() {
    if (inFlight) return;
    inFlight = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) {
        if (!t) return;
        var j;
        /* parse-based guard, never content-type: the Noibu wrapper hides headers */
        try { j = JSON.parse(t); } catch (e) { return; }
        if (j && typeof j.item_count !== 'undefined') paint(j.item_count);
      })
      .catch(function () {})
      .then(function () { inFlight = false; });
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(sync, typeof delay === 'number' ? delay : 60);
  }
  window.hvSyncCartCount = schedule;

  /* ---- intercept every cart mutation, whoever makes it ---- */
  var _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function (input) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var hit = MUTATORS.test(url);
      var p = _fetch.apply(this, arguments);
      if (hit && p && typeof p.then === 'function') {
        p.then(function () { schedule(); }, function () { schedule(); });
      }
      return p;
    };
  }

  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var _open = XHR.prototype.open;
    var _send = XHR.prototype.send;
    XHR.prototype.open = function (m, u) {
      try { this.__hvCartHit = MUTATORS.test(String(u)); } catch (e) {}
      return _open.apply(this, arguments);
    };
    XHR.prototype.send = function () {
      try {
        if (this.__hvCartHit) {
          this.addEventListener('loadend', function () { schedule(); });
        }
      } catch (e) {}
      return _send.apply(this, arguments);
    };
  }

  /* ---- events other layers already emit ---- */
  ['cart:updated', 'cart:refresh', 'cart:build', 'ajaxCart.afterCartLoad', 'hv:cart-changed']
    .forEach(function (evt) {
      document.addEventListener(evt, function () { schedule(); });
    });

  /* ---- first paint + bfcache restore ---- */
  function start() { claim(); schedule(0); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) start(); });
})();

/* =============================================================
   HV RAIL — "Complete your cart" / related products renderer
   Added 2026-08-28. Replaces the StorePass rail
   (#related-products-store-pass + store-pass-recently-viewed.js)
   with native markup we own, matching live pixel-for-pixel.

   TWO SOURCES, chosen per section instance in the theme editor:

   * recently_viewed  — the shopify_recently_viewed cookie, exactly
     what live's cart rail uses. NOT driven by cart contents, which
     is why live's rail can read empty while the cart has items.
   * recommendations  — /recommendations/products.json, trying
     intent=complementary first (your Search & Discovery picks) and
     falling back to intent=related (Shopify's own similarity:
     vendor, product type, etc). VERIFIED on this store 2026-08-28:
     complementary returns 0 products because nothing is curated
     yet; related returns 6, all in stock. The fallback means
     curated picks take over automatically once you add them.

   In-stock filtering is a setting, default on.

   Add-to-cart posts to /cart/add.js on purpose, so the max-per-order
   Validation Function and the Order Protect checkout engine both
   still apply, and the cart-count owner above picks the add up for
   free via its fetch interception. Never manipulate cart fee lines
   from theme code.

   Styling: assets/hv-rail.css   Spec: COMPLETE-YOUR-CART-SPEC.md
   ============================================================= */
(function () {
  if (window.__hvRail) return;
  window.__hvRail = true;

  var MONEY = function (cents) {
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2);
  };

  function handlesFromCookie() {
    var raw = '';
    try {
      var m = document.cookie.match(/(?:^|;\s*)shopify_recently_viewed=([^;]*)/);
      raw = m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return []; }
    return raw.split(/[\s,]+/).filter(Boolean);
  }

  /* Writes the cookie back the SAME way theme.dev.js's writeHandles() does — same
     name, path, domain and 90-day expiry — so this overwrites the one cookie rather
     than minting a second one on a different path/domain. Used by the Continue
     shopping dismiss (X): removing a handle here is what makes a dismissed product
     stay gone across reloads, and viewing it again re-adds it through the theme's own
     recordRecentlyViewed(), which is exactly "until they shop for more products". */
  function writeHandlesToCookie(handles) {
    try {
      var expires = new Date();
      expires.setDate(expires.getDate() + 90);
      document.cookie = 'shopify_recently_viewed=' + encodeURIComponent(handles.join(' '))
        + '; expires=' + expires.toUTCString()
        + '; path=/; domain=' + window.location.hostname;
    } catch (e) {}
  }

  /* DISMISS MEMORY (2026-09-03). Editing the cookie is enough for the homepage rail,
     which shows history or nothing. The cart rail is different: it tops itself up from
     cart pairings and a fallback collection, so a dismissed card may never have been in
     the cookie at all, and an emptied rail would refill itself on the next visit — the
     opposite of "make it disappear". Two small per-browser records fix both:

       hv_rail_dismissed  handles the shopper struck out. Filtered from EVERY tier.
                          A handle that turns up in the cookie again was re-opened, so
                          it is forgiven the next time a rail fills.
       hv_rail_muted      set when a rail is cleared to zero. A muted rail skips the
                          fallback chain and stays hidden. Cleared the moment the cookie
                          holds a product again, i.e. they shopped for something.

     localStorage, not sessionStorage: a shopper who removes everything and comes back
     tomorrow should not find it all back. Every access is wrapped — Safari private
     mode throws on write. */
  var DISMISS_KEY = 'hv_rail_dismissed';
  var MUTE_KEY = 'hv_rail_muted';

  function loadDismissed() {
    try {
      var a = JSON.parse(localStorage.getItem(DISMISS_KEY) || '[]');
      return Array.isArray(a) ? a : [];
    } catch (e) { return []; }
  }
  function saveDismissed(list) {
    try { localStorage.setItem(DISMISS_KEY, JSON.stringify(list.slice(0, 60))); } catch (e) {}
  }
  function railsMuted() {
    try { return localStorage.getItem(MUTE_KEY) === '1'; } catch (e) { return false; }
  }
  function setRailsMuted(on) {
    try { on ? localStorage.setItem(MUTE_KEY, '1') : localStorage.removeItem(MUTE_KEY); } catch (e) {}
  }

  function dismissHandle(handle) {
    writeHandlesToCookie(handlesFromCookie().filter(function (h) { return h !== handle; }));
    var d = loadDismissed();
    if (d.indexOf(handle) < 0) { d.unshift(handle); saveDismissed(d); }
  }

  /* The X itself, shared by both card shapes. A <button> layered above the card's
     links (z-index in CSS) that stops the event, so a press never also opens the
     product. Removes the card; when it was the last one the section gets
     .hv-rail--empty (the same hook render() uses when nothing was found) and the rails
     are muted — see DISMISS MEMORY above. */
  function dismissButton(root, p, o, cls) {
    var btn = el('button', cls);
    btn.type = 'button';
    btn.innerHTML = ICON.close;
    btn.setAttribute('aria-label', o.dismissLabel + ' — ' + (p.title || ''));
    btn.title = o.dismissLabel;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var rail = root.parentNode;
      var section = rail && rail.closest ? rail.closest('.hv-rail') : null;
      dismissHandle(p.handle);
      if (root.parentNode) root.parentNode.removeChild(root);
      if (rail && !rail.querySelector('.hv-rail__card, .hv-continue__card')) {
        if (section) section.classList.add('hv-rail--empty');
        setRailsMuted(true);
      }
    });
    return btn;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  var ICON = {
    minus: '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="M2.5 8h11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="none"/></svg>',
    plus:  '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="M8 2.5v11M2.5 8h11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="none"/></svg>',
    arrowRight: '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="M2.5 8h11M9 3.5 13.5 8 9 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>',
    cart: '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false"><path d="M1.5 2h2.2l1.1 9.2a1.3 1.3 0 0 0 1.3 1.15h8.1a1.3 1.3 0 0 0 1.28-1.06l1.02-5.4H4.6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" fill="none"/><circle cx="7.4" cy="16.2" r="1.5" fill="currentColor"/><circle cx="14.2" cy="16.2" r="1.5" fill="currentColor"/></svg>',
    close: '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" fill="none"/></svg>',
    check: '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="m3 8.4 3.2 3.2L13 4.8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>',
    alert: '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="M8 4.2v4.4M8 11.3v.1" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/><circle cx="8" cy="8" r="6.3" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>'
  };

  /* ---- status, verified against all 30 cards on live's collection grid ----
     Pill and button are INDEPENDENT axes:
       button  <- availability alone
       pill    <- OUT OF STOCK if unavailable (wins), else PRE ORDER if the
                  product carries the *Show_Pre Orders tag, else nothing.
     Proof case: reprint-...-journey-together has *Show_Pre Orders AND is
     unavailable -> live shows OUT OF STOCK + Notify Me, not PRE ORDER.
     An in-stock pre-order gets the normal red Add to Cart. */
  function statusOf(p, o) {
    var available = p.available !== false;
    /* 2026-08-30: widened to match snippets/preorder-check.liquid so the rail, the PDP
       badge and the PDP button can never disagree. Tag match stays exact; the title
       match is a lowercased substring, same as the snippet. */
    var tags = p.tags || [];
    var isPreOrder = tags.indexOf(o.preOrderTag) > -1;
    if (!isPreOrder) {
      for (var ti = 0; ti < tags.length; ti++) {
        var tg = String(tags[ti]).toLowerCase();
        if (tg === '_preorder' || tg === 'preorder' || tg === 'pre order' || tg === 'pre-order') { isPreOrder = true; break; }
      }
    }
    if (!isPreOrder) {
      var ttl = String(p.title || '').toLowerCase();
      if (ttl.indexOf('pre order') > -1 || ttl.indexOf('pre-order') > -1 || ttl.indexOf('preorder') > -1) isPreOrder = true;
    }
    /* 2026-09-04: $0 + in stock = "contact us" product (quote / call the store).
       $0 + sold out is just sold out (Notify Me). Neither can be added to cart. */
    var contact = Number(p.price) === 0; /* stock ignored by rule */
    if (contact) available = true;
    return {
      available: available,
      contact: contact,
      pill: !available ? 'oos' : (isPreOrder ? 'preorder' : null)
    };
  }

  function card(p, o) {
    var root = el('div', 'hv-rail__card');
    var url = '/products/' + p.handle;
    var st = statusOf(p, o);

    if (st.pill) {
      var tag = el('span', 'hv-rail__tag hv-rail__tag--' + st.pill,
                   st.pill === 'oos' ? o.oosLabel : o.preOrderLabel);
      root.appendChild(tag);
    }

    var imgWrap = el('div', 'hv-rail__image');
    var a = el('a');
    a.href = url;
    a.setAttribute('aria-label', p.title || '');
    if (p.featured_image) {
      var img = el('img');
      img.src = p.featured_image;
      img.alt = p.title || '';
      img.loading = 'lazy';
      a.appendChild(img);
    }
    imgWrap.appendChild(a);

    var info = el('div', 'hv-rail__info');

    var title = el('div', 'hv-rail__title');
    var ta = el('a', null, p.title || '');
    ta.href = url;
    title.appendChild(ta);

    /* 2026-09-07: vendor is TEXT, not a link (Edmond — vendors are not clickable
       anywhere on the site). Was an <a> to /collections/vendors?q=<vendor>.
       textContent, never innerHTML: vendor is store-controlled data and must not be
       parsed as markup. The div keeps its class so hv-rail__vendor styling is unchanged.
       Matched by snippets/product.liquid and sections/hv-collection-row.liquid — all
       three were unlinked together; restore all three if a vendor link is ever wanted. */
    var vendor = el('div', 'hv-rail__vendor');
    if (p.vendor && o.showVendor) {
      vendor.textContent = p.vendor;
    }

    var priceRow = el('div', 'hv-rail__price-container');
    /* 2026-09-09: reserve the price row rather than removing it. `hidden` pulls
       the row out of flow ([hidden]{display:none!important} in the theme reset),
       so a $0 "Contact Us" card lost one line and its stepper + CTA rode 25px
       above every other card in the rail — measured on /cart, Contact Us cards
       CTA top 1637 vs 1662 on priced cards. visibility keeps the 19px box (the
       "$0.00" text is what gives it height), so the CTAs share a baseline, and
       the row stays out of the accessibility tree. */
    if (Number(p.price) === 0) priceRow.style.visibility = 'hidden';
    priceRow.appendChild(el('div', 'hv-rail__price', MONEY(p.price)));
    if (p.compare_at_price && Number(p.compare_at_price) > Number(p.price)) {
      priceRow.appendChild(el('strike', 'hv-rail__msrp', MONEY(p.compare_at_price)));
    }

    /* quantity stepper: live keeps it on out-of-stock cards too */
    var qty = el('div', 'hv-rail__qty');
    var minus = el('button', 'hv-rail__qty-btn');
    minus.type = 'button';
    minus.innerHTML = ICON.minus;
    minus.setAttribute('aria-label', 'Decrease quantity');
    var input = el('input', 'hv-rail__qty-input');
    input.type = 'number';
    input.min = '1';
    input.value = '1';
    input.setAttribute('aria-label', 'Quantity');
    var plus = el('button', 'hv-rail__qty-btn');
    plus.type = 'button';
    plus.innerHTML = ICON.plus;
    plus.setAttribute('aria-label', 'Increase quantity');
    minus.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    /* 2026-09-07: honour a `max` if one is present. These JS-built rails (Continue
       shopping / Complete your cart / Related products) are assembled from
       /products/<handle>.js, /collections/x/products.json and
       /recommendations/products.json — NONE of which return metafields — so they
       cannot read custom.quantity_max today and this ceiling is INERT for them.

       It is here so the mechanism exists the moment a limit reaches these cards,
       and because the Liquid-rendered rows in sections/hv-collection-row.liquid
       reuse this same class; if one of those is ever built through this path it
       must not climb past its cap. Do not read this as "the JS rails are capped" —
       they are not. The cart-wide Validation Function and the 422 path remain the
       only enforcement for them. */
    plus.addEventListener('click', function () {
      var next = (parseInt(input.value, 10) || 1) + 1;
      var cap = parseInt(input.getAttribute('max'), 10);
      input.value = (cap && next > cap) ? cap : next;
    });
    qty.appendChild(minus); qty.appendChild(input); qty.appendChild(plus);
    if (!o.showQuantity) qty.style.display = 'none';
    /* sold out: keep the stepper for row alignment, greyed + inert (2026-09-04) */
    if (!st.available) {
      qty.className += ' hv-rail__qty--disabled';
      qty.setAttribute('aria-disabled', 'true');
      minus.disabled = plus.disabled = input.disabled = true;
    }

    var variant = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
    /* an in-stock pre-order gets the pre-order label; live uses the plain Add to Cart
       here, so this is a deliberate divergence requested 2026-08-30. */
    var ctaText = st.contact ? (o.contactLabel || 'Contact Us')
                : st.available ? (st.pill === 'preorder' ? o.preOrderCtaLabel : o.ctaLabel) : o.notifyLabel;
    var cta = el('button', 'hv-rail__cta', ctaText);
    cta.type = 'button';
    /* live leaves Notify Me enabled -- it is a back-in-stock hook, not a
       dead control -- so it is NOT disabled here either. */
    if (!st.available) cta.className += ' hv-rail__cta--notify';
    if (st.contact) { cta.className += ' hv-rail__cta--contact'; qty.className += ' hv-rail__qty--disabled'; minus.disabled = plus.disabled = input.disabled = true; }

    cta.addEventListener('click', function () {
      if (st.contact) { window.location.href = url; return; }
      if (!st.available) {
        /* back-in-stock: hand off to Klaviyo if present, else the PDP */
        try {
          if (window.klaviyo && typeof window.klaviyo.push === 'function' && variant) {
            window.klaviyo.push(['openBackInStockModal', { variant: variant.id, product: p.id }]);
            return;
          }
        } catch (e) {}
        window.location.href = url;
        return;
      }
      if (!variant) return;
      var q = Math.max(1, parseInt(input.value, 10) || 1);
      cta.disabled = true;
      var original = cta.textContent;
      cta.textContent = o.addingLabel;
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: q })
      })
        .then(function (r) { return r.text().then(function (t) { return { ok: r.ok, t: t }; }); })
        .then(function (res) {
          /* parse-based guard, never content-type: the Noibu wrapper hides headers */
          var msg;
          if (!res.ok) {
            var reason = '';
            try { reason = (JSON.parse(res.t) || {}).description || ''; } catch (e) {}
            msg = reason ? o.limitLabel : 'Unavailable';
          } else {
            msg = o.addedLabel;
          }
          cta.textContent = msg;
          setTimeout(function () { cta.textContent = original; cta.disabled = false; }, 1800);
        })
        .catch(function () {
          cta.textContent = original;
          cta.disabled = false;
        });
    });

    info.appendChild(title);
    info.appendChild(vendor);
    info.appendChild(priceRow);
    info.appendChild(qty);
    info.appendChild(cta);

    root.appendChild(imgWrap);
    root.appendChild(info);
    /* Top-right of the image band; the status pill owns the top-left. Only rails whose
       source is the shopper's own history ask for this (see the section Liquid). */
    if (o.showDismiss) root.appendChild(dismissButton(root, p, o, 'hv-rail__dismiss'));
    return root;
  }

  function byHandles(handles) {
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (t) { if (!t) return null; try { return JSON.parse(t); } catch (e) { return null; } })
        .catch(function () { return null; });
    }));
  }

  function recommend(productId, limit, intent) {
    /* Over-fetch. take() drops events, service SKUs, out-of-stock items and the
       current product, so asking for exactly `limit` meant a few exclusions emptied
       the tier and forced a SECOND sequential request. Measured 2026-08-30 on a
       singles PDP: complementary at 1087ms (155ms) then related at 1243ms (546ms) —
       ~700ms of avoidable serial latency. Shopify caps this endpoint at 10. */
    var ask = Math.min(10, Math.max(limit * 3, limit));
    var url = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) +
              '&intent=' + intent + '&limit=' + ask;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) {
        if (!t) return [];
        try { return (JSON.parse(t) || {}).products || []; } catch (e) { return []; }
      })
      .catch(function () { return []; });
  }

  /* ---- mobile auto-rotate ----------------------------------------------
     Advances the rail one card at a time on mobile, looping back to the start
     when it reaches the end. Built on the NATIVE scroll + scroll-snap already
     in hv-rail.css rather than a transform carousel, so a manual swipe and an
     auto-advance are the same mechanism and cannot desync -- and the rail
     still works with JS half-loaded.

     Stops for the shopper, never fights them:
       * any touch / pointer / wheel / key on the rail stops it for good --
         once someone takes control they are browsing, not watching;
       * pauses while the tab is hidden or the rail is scrolled out of view,
         so it is not burning battery in a background tab;
       * never starts under prefers-reduced-motion;
       * desktop is untouched -- the wrap grid has nothing to scroll.
     ---------------------------------------------------------------------- */
  /* CONTINUE-SHOPPING CARD — the wide, horizontal variant.

     Deliberately NOT an add-to-cart card. This rail answers "where was I?", and a
     shopper resuming a browse has not decided yet — the useful action is to reopen
     the product, not to buy the thing they walked away from. Dropping the quantity
     stepper and the ATC button is what lets the card be one line tall and lets four
     fit across, which is the whole point of the layout.

     ONE link, wrapping everything. The reference design has both a "View item" link
     and a round arrow button next to it; built literally that would be three tap
     targets on one card going to the same URL, which a screen reader reads out three
     times. Here the <a> IS the card, and the label and arrow inside it are decorative
     (aria-hidden), so it announces once and the entire card is the tap target. */
  /* Shared add-to-cart behaviour for the quick-add button. Kept as its own small
     helper rather than refactoring card()'s inline handler: that handler is live on the
     cart and PDP rails, and rewriting working add-to-cart code to save a few lines is
     the kind of change that buys nothing and can cost an outage.

     Posts to /cart/add.js on purpose so the max-per-order Validation Function and the
     Order Protect checkout engine both still apply, and the cart-count owner picks the
     add up through its fetch interception. Never touch cart fee lines from theme code.

     Success is judged by parsing the body, never by content-type — the Noibu wrapper
     hides response headers. */
  function bindAdd(btn, p, o, st, url, setState) {
    var variant = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
    /* Default for a TEXT button; the icon button passes its own setState, because
       writing textContent on an icon button would delete the SVG inside it. */
    if (!setState) {
      setState = function (msg) { btn.textContent = msg; };
    }
    btn.addEventListener('click', function (e) {
      /* The card is one big stretched link; without this the click also navigates. */
      e.preventDefault();
      e.stopPropagation();

      if (st.contact) { window.location.href = url; return; }
      if (!st.available) {
        try {
          if (window.klaviyo && typeof window.klaviyo.push === 'function' && variant) {
            window.klaviyo.push(['openBackInStockModal', { variant: variant.id, product: p.id }]);
            return;
          }
        } catch (err) {}
        window.location.href = url;
        return;
      }
      if (!variant) return;

      btn.disabled = true;
      var original = btn.textContent;
      setState(o.addingLabel, 'adding', original);
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      })
        .then(function (r) { return r.text().then(function (t) { return { ok: r.ok, t: t }; }); })
        .then(function (res) {
          var msg, phase;
          if (!res.ok) {
            var reason = '';
            try { reason = (JSON.parse(res.t) || {}).description || ''; } catch (err) {}
            msg = reason ? o.limitLabel : 'Unavailable';
            phase = 'error';
          } else {
            msg = o.addedLabel;
            phase = 'added';
          }
          setState(msg, phase, original);
          setTimeout(function () { setState(original, 'idle', original); btn.disabled = false; }, 1800);
        })
        .catch(function () {
          setState(original, 'idle', original);
          btn.disabled = false;
        });
    });
  }

  function continueCard(p, o) {
    /* A DIV, not an <a>, once there is a button inside it. A <button> nested in an <a>
       is invalid HTML and browsers disagree on what a click means. The card stays fully
       clickable via a stretched pseudo-element on the title link (see the section CSS),
       which keeps ONE link in the accessibility tree and lifts the button above it. */
    var root = el('div', 'hv-continue__card');
    var url = '/products/' + p.handle;

    var media = el('div', 'hv-continue__media');
    if (p.featured_image) {
      var img = el('img');
      img.src = p.featured_image;
      /* alt empty on purpose: the title below is inside the same link, so the
         accessible name is already the product. Alt text here would duplicate it. */
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      media.appendChild(img);
    }
    root.appendChild(media);

    var info = el('div', 'hv-continue__info');
    var st = statusOf(p, o);
    /* Eyebrow row: "Recently viewed" + the status pill on one line. The pill used to
       be pinned over the thumbnail's top-left corner and covered the product art
       (Edmond, 2026-09-04) — here it reads as part of the label and the image stays
       clear. Row is emitted whenever either piece exists. */
    if (o.eyebrowLabel || st.pill) {
      var eyebrowRow = el('div', 'hv-continue__eyebrow-row');
      if (o.eyebrowLabel) eyebrowRow.appendChild(el('span', 'hv-continue__eyebrow', o.eyebrowLabel));
      if (st.pill) {
        eyebrowRow.appendChild(el('span', 'hv-continue__pill hv-continue__pill--' + st.pill,
                                  st.pill === 'oos' ? o.oosLabel : o.preOrderLabel));
      }
      info.appendChild(eyebrowRow);
    }

    /* The one real link. Its ::after is stretched over the whole card in CSS, so the
       card is the tap target while the accessible name stays just the product title. */
    var title = el('span', 'hv-continue__title');
    var titleLink = el('a', 'hv-continue__title-link', p.title || '');
    titleLink.href = url;
    title.appendChild(titleLink);
    info.appendChild(title);

    var price = el('span', 'hv-continue__price', MONEY(p.price));
    if (!st.available) price.className += ' hv-continue__price--oos';
    if (Number(p.price) === 0) price.className += ' hv-continue__price--hidden';
    info.appendChild(price);

    if (!o.showAtc && o.viewLabel) {
      var cta = el('span', 'hv-continue__cta');
      cta.setAttribute('aria-hidden', 'true');
      cta.appendChild(el('span', null, o.viewLabel));
      var arrow = el('span', 'hv-continue__cta-arrow');
      arrow.innerHTML = ICON.arrowRight;
      cta.appendChild(arrow);
      info.appendChild(cta);
    }

    root.appendChild(info);

    /* Actions column on the right. The view arrow is OFF by default: the whole card is
       already a link via the stretched title, so an arrow that goes to the same place
       is a second control for an action the shopper can take by pressing anywhere. It
       was also the only thing making the cart button ambiguous — with one button left,
       the meaning of pressing it is obvious. Kept behind a setting for the layouts
       where quick add is turned off and the card needs a visible affordance. */
    var actions = el('div', 'hv-continue__actions');

    if (o.showGoArrow) {
      var go = el('span', 'hv-continue__go');
      go.setAttribute('aria-hidden', 'true');
      go.innerHTML = ICON.arrowRight;
      actions.appendChild(go);
    }

    if (o.showAtc) {
      /* ICON-ONLY BUTTON. Three things it has to get right that a text button got for
         free:

         1. An accessible NAME. A button whose only content is a decorative SVG
            announces as "button" and nothing else, so aria-label carries the label —
            and it names the product too, since five identical "Add to cart" buttons in
            a row tell a screen reader user nothing about which is which.
         2. A visible name on hover, via title, for anyone who does not read the glyph.
         3. RESULT FEEDBACK. The text button said "Added" in place of its label; an
            icon button cannot, so the glyph swaps to a tick and the words go to a
            role="status" region, which is what actually gets announced. Writing
            textContent here would delete the SVG — hence setState. */
      var label = st.contact ? (o.contactLabel || 'Contact Us') : st.available ? o.ctaLabel : o.notifyLabel;
      var full = label + ' — ' + (p.title || '');
      var add = el('button', 'hv-continue__add');
      add.type = 'button';
      if (st.contact) add.className += ' hv-continue__add--contact';
      /* REQUIRED for the "Added to your cart" popover, and not optional styling.
         The popover deliberately refuses to fire on a bare /cart/add.js response: its
         onAdd() bails unless a click on a RECOGNISED add-to-cart control happened in
         the previous 6 seconds (the `pend` gate above). That gate is what stops the
         popover appearing for background and bot adds — Reactiv, cart restores, the
         Order Protect fee line — so the right fix is to be recognised, not to weaken
         the gate. `data-add-to-cart` is already one of the selectors it watches.

         The Newest Arrivals row never needed this because its button is inside a real
         <form action="/cart/add">, which the gate matches on its own. This card has no
         form, so it has to say so explicitly. */
      add.setAttribute('data-add-to-cart', '');
      add.innerHTML = st.available ? ICON.cart : ICON.alert;
      add.setAttribute('aria-label', full);
      add.title = label;
      if (!st.available) add.className += ' hv-continue__add--notify';

      var status = el('span', 'hv-continue__status');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');

      bindAdd(add, p, o, st, url, function (msg, phase) {
        status.textContent = phase === 'idle' ? '' : msg;
        add.setAttribute('aria-label', phase === 'idle' ? full : msg + ' — ' + (p.title || ''));
        add.title = phase === 'idle' ? label : msg;
        add.className = 'hv-continue__add'
          + (st.available ? '' : ' hv-continue__add--notify')
          + (phase === 'idle' ? '' : ' hv-continue__add--' + phase);
        if (phase === 'added') add.innerHTML = ICON.check;
        else if (phase === 'error') add.innerHTML = ICON.alert;
        else if (phase === 'idle') add.innerHTML = st.available ? ICON.cart : ICON.alert;
      });

      actions.appendChild(add);
      actions.appendChild(status);
    }

    root.appendChild(actions);

    /* DISMISS (X), top-right. "Not this one" is a real need on a history rail — the
       gift already bought, the box looked at once — and without it the only way to
       clear a card is to wait 90 days for the cookie to lapse. Shared helper: it edits
       the source (cookie + dismissed list) rather than just the DOM, so the card stays
       gone on reload and on the cart's rail too, and it hides the section when the last
       card goes. Opening the product again brings it back. */
    if (o.showDismiss) root.appendChild(dismissButton(root, p, o, 'hv-continue__dismiss'));

    return root;
  }

  function autoRotate(rail) {
    var secs = parseFloat(rail.getAttribute('data-autoplay')) || 0;
    if (!secs) return;

    var mobile = window.matchMedia('(max-width: 767px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var timer = null;
    var stopped = false;
    var onScreen = true;

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function step() {
      if (stopped || !onScreen || document.hidden || !mobile.matches || reduced.matches) return;
      var card = rail.querySelector('.hv-rail__card');
      if (!card) return;
      var cs = getComputedStyle(rail);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      var stride = card.getBoundingClientRect().width + gap;
      var max = rail.scrollWidth - rail.clientWidth;
      if (max <= 1) return;                       /* nothing to scroll */
      /* within half a card of the end -> loop home */
      var next = rail.scrollLeft >= max - stride / 2 ? 0 : rail.scrollLeft + stride;
      try {
        rail.scrollTo({ left: next, behavior: 'smooth' });
      } catch (e) {
        rail.scrollLeft = next;                   /* older Safari */
      }
    }

    function start() {
      stop();
      if (stopped || reduced.matches || !mobile.matches) return;
      timer = setInterval(step, secs * 1000);
    }

    ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach(function (ev) {
      rail.addEventListener(ev, function () { stopped = true; stop(); }, { passive: true });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    if (mobile.addEventListener) {
      mobile.addEventListener('change', start);
      reduced.addEventListener('change', function () { reduced.matches ? stop() : start(); });
    }

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        if (onScreen) { start(); } else { stop(); }
      }, { threshold: 0.2 }).observe(rail);
    } else {
      start();
    }
  }

  /* ---- source normalisation ---------------------------------------------
     THREE endpoints feed this rail and they do NOT agree on shape:
       /products/{handle}.js           price in CENTS            (1495)
       /recommendations/products.json  price in CENTS            (1495)
       /collections/{h}/products.json  price as a DECIMAL STRING ("14.95"),
                                       images[] instead of featured_image,
                                       and no product-level `available`
     Feeding the third one straight into card() renders $14.95 as $0.15.
     Everything passes through normalize() before it reaches card().
     ---------------------------------------------------------------------- */
  function cents(v) {
    if (v == null || v === '') return 0;
    if (typeof v === 'number') return Math.round(v);
    var str = String(v);
    return str.indexOf('.') > -1 ? Math.round(parseFloat(str) * 100) : (parseInt(str, 10) || 0);
  }

  function normalize(p) {
    if (!p || !p.handle || !p.id) return null;
    var variants = (p.variants || []).map(function (v) {
      return { id: v.id, available: v.available !== false, price: cents(v.price) };
    });
    var first = variants[0] || {};
    /* 2026-10-04: the card price is the FIRST IN-STOCK variant (NM, then LP, then MP),
       not the feed's product-level `price`, which is the cheapest variant even when it
       is sold out. That showed a $750 card (in-stock NM, unpriced sold-out LP/MP) with
       no price at all: $0 tripped the contact-us rule below. Same rule as the homepage
       singles strip and the PDP. Falls back to the first variant when none is in stock. */
    var sellable = variants.filter(function (v) { return v.available; })[0] || first;
    var img = p.featured_image;
    if (!img && p.images && p.images.length) {
      img = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0] && p.images[0].src);
    }
    return {
      id: p.id,
      title: p.title || '',
      handle: p.handle,
      vendor: p.vendor || '',
      /* /recommendations/products.json and /collections/x/products.json disagree on the
         key for product type, so read both. Used to keep event tickets out of the rail. */
      type: p.product_type || p.type || '',
      tags: p.tags || [],
      featured_image: img || null,
      price: sellable.price != null ? sellable.price : (p.price != null ? cents(p.price) : 0),
      compare_at_price: cents(
        p.compare_at_price != null ? p.compare_at_price
          : (p.variants && p.variants[0] && p.variants[0].compare_at_price)
      ),
      variants: variants,
      available: p.available !== undefined
        ? p.available !== false
        : variants.some(function (v) { return v.available; })
    };
  }

  function cartInfo() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) { if (!t) return null; try { return JSON.parse(t); } catch (e) { return null; } })
      .catch(function () { return null; });
  }

  function fromCollection(handle, want) {
    if (!handle) return Promise.resolve([]);
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + want,
                 { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) {
        if (!t) return [];
        try { return (JSON.parse(t) || {}).products || []; } catch (e) { return []; }
      })
      .catch(function () { return []; });
  }

  /* ---- fill -------------------------------------------------------------
     The rail must never render as a heading and a divider above nothing, so
     products are gathered through a ladder and it only gives up at the end:

       1. the chosen source -- recently-viewed cookie, or complementary /
          related picks when the section is set to recommendations;
       2. what pairs with what is ALREADY in the cart (complementary, then
          related, off the first cart line) -- on a "Complete your cart" rail
          this is the most on-topic top-up available;
       3. a fallback collection the merchant picks in the theme editor.

     Each tier only tops up the shortfall and stops the moment the rail is
     full. Products already in the cart are skipped by default -- offering
     someone what they have just added is the one thing this rail must not do.
     If every tier comes up dry the whole section hides itself, so the heading
     never strands above an empty row.
     ---------------------------------------------------------------------- */
  function fill(rail) {
    var limit = parseInt(rail.getAttribute('data-limit'), 10) || 5;
    var attr = function (n, d) { var v = rail.getAttribute(n); return v == null || v === '' ? d : v; };
    var o = {
      showVendor: attr('data-show-vendor', 'true') !== 'false',
      showQuantity: attr('data-show-quantity', 'true') !== 'false',
      ctaLabel: attr('data-cta-label', 'Add to Cart'),
      notifyLabel: attr('data-notify-label', 'Notify Me'),
      preOrderCtaLabel: attr('data-preorder-cta-label', 'Pre Order'),
      preOrderLabel: attr('data-preorder-label', 'Pre order'),
      oosLabel: attr('data-oos-label', 'Out of Stock'),
      preOrderTag: attr('data-preorder-tag', '*Show_Pre Orders'),
      addingLabel: attr('data-adding-label', 'Adding…'),
      addedLabel: attr('data-added-label', 'Added'),
      limitLabel: attr('data-limit-label', 'Limit reached'),
      eyebrowLabel: attr('data-eyebrow-label', ''),
      viewLabel: attr('data-view-label', 'View item'),
      showAtc: attr('data-show-atc', 'false') === 'true',
      showGoArrow: attr('data-show-arrow', 'false') === 'true',
      showDismiss: attr('data-show-dismiss', 'false') === 'true',
      dismissLabel: attr('data-dismiss-label', 'Remove')
    };
    var source = rail.getAttribute('data-source') || 'recently_viewed';
    var inStockOnly = rail.getAttribute('data-in-stock') !== 'false';
    var productId = rail.getAttribute('data-product-id');
    var fallbackHandle = attr('data-fallback-collection', '');
    var excludeCart = attr('data-exclude-cart', 'true') !== 'false';
    /* STRICT SOURCE — "Continue shopping" shows the shopper's OWN history or nothing.
       The fallback chain below (cart pairings, then a fallback collection) exists to
       keep the cart rail full, which is right there and wrong here: it would put
       products a shopper has never opened under the words "Recently viewed". With
       strict on, an empty history leaves picked[] empty, render() adds .hv-rail--empty,
       and the section hides itself in CSS. */
    var strictSource = rail.getAttribute('data-strict-source') === 'true';
    var variant = attr('data-hv-variant', 'tile');
    var excludeTypes = String(attr('data-exclude-types', 'Event,Ticket'))
      .split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
    var excludeHandles = String(attr('data-exclude-handles', 'protectmyorder,split-shipping'))
      .split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);

    var picked = [];
    var seen = {};
    var skip = {};

    /* DISMISS MEMORY, applied on dismissable rails only — the PDP recommendations rail
       never shows an X and must never go quiet because the shopper cleared the cart
       rail. Order matters: forgive first (a dismissed handle back in the cookie was
       re-opened), then unmute if the cookie holds anything at all, then decide. */
    var cookieNow = handlesFromCookie();
    var dismissed = o.showDismiss ? loadDismissed() : [];
    if (dismissed.length && cookieNow.length) {
      var kept = dismissed.filter(function (h) { return cookieNow.indexOf(h) < 0; });
      if (kept.length !== dismissed.length) { dismissed = kept; saveDismissed(kept); }
    }
    if (o.showDismiss && cookieNow.length && railsMuted()) setRailsMuted(false);
    var muted = o.showDismiss && railsMuted();

    /* returns true once the rail is full, so callers can stop early */
    function take(products) {
      (products || []).forEach(function (raw) {
        if (picked.length >= limit) return;
        var p = normalize(raw);
        if (!p) return;
        if (seen[p.id] || skip[p.id]) return;
        if (dismissed.length && dismissed.indexOf(p.handle) > -1) return;
        if (productId && String(p.id) === String(productId)) return;
        if (inStockOnly && !p.available) return;
        /* Event tickets are POS/in-store products and must never be recommended.
           Matched on PRODUCT TYPE, never on tags: `tag:Type_Event` is poisoned —
           Shopify tokenises it and it also matches ~1,259 SWU singles carrying
           `Card Type_Event`. Verified 2026-08-30: the Blackwell locals and the
           Lorcana tournaments all carry productType "Event". */
        if (excludeTypes.length && p.type &&
            excludeTypes.indexOf(String(p.type).trim().toLowerCase()) > -1) return;
        /* Order Protect has an EMPTY product type (verified 2026-08-30), so type
           filtering cannot catch it — excluded by handle instead. */
        if (excludeHandles.length &&
            excludeHandles.indexOf(String(p.handle).trim().toLowerCase()) > -1) return;
        seen[p.id] = 1;
        picked.push(p);
      });
      return picked.length >= limit;
    }

    function primary() {
      if (source === 'recommendations' && productId) {
        /* 2026-08-30: fired in PARALLEL, not serially. /recommendations/products.json
           takes only product_id, intent and limit — there is no server-side exclusion
           param, so events and service SKUs can only be dropped client-side, which is
           what made a short first tier trigger a second request. Measured before:
           complementary at 1087ms then related at 1243ms (546ms) = ~700ms of serial
           wait. Both now leave together and take() dedupes via `seen`, so complementary
           still wins on order while related supplies the surplus in the same
           round-trip window. */
        /* 2026-09-06 (Edmond): SAME COLLECTION FIRST. Shopify's related intent is
           popularity-weighted — a Marvel Legendary expansion got a Vs. System deck and
           hockey boxes. The product's own collection (the one in the URL, else its most
           specific non-utility collection — data-fallback-collection) is fetched in the
           same round trip and ranks first: recommendations that are IN that collection,
           then the rest of the collection, then the remaining recommendations. The
           collection was tier 3 before; it is now the spine and tier 3 is redundant. */
        return Promise.all([
          recommend(productId, limit, 'complementary'),
          recommend(productId, limit, 'related'),
          fromCollection(fallbackHandle, Math.max(limit * 3, 12))
        ]).then(function (lists) {
          var recs = (lists[0] || []).concat(lists[1] || []);
          var coll = lists[2] || [];
          var inColl = {};
          coll.forEach(function (p) { if (p && p.id) inColl[p.id] = 1; });
          var first = recs.filter(function (p) { return p && inColl[p.id]; });
          var rest = recs.filter(function (p) { return !(p && inColl[p.id]); });
          return first.concat(coll).concat(rest);
        });
      }
      var handles = handlesFromCookie().slice(0, limit);
      return handles.length ? byHandles(handles) : Promise.resolve([]);
    }

    function render() {
      var section = rail.closest ? rail.closest('.hv-rail') : null;
      if (!picked.length) {
        if (section) section.classList.add('hv-rail--empty');
        return;
      }
      var frag = document.createDocumentFragment();
      var build = variant === 'continue' ? continueCard : card;
      picked.forEach(function (p) { frag.appendChild(build(p, o)); });
      rail.appendChild(frag);
      if (section) section.classList.remove('hv-rail--empty');
      autoRotate(rail);
    }

    /* 2026-08-30 — cart lookup and product lookup now run CONCURRENTLY.
       Previously primary() was chained inside cartInfo().then(), so the rail could not
       ask for products until /cart.js came back. Measured on a singles PDP: custom.js
       executed at 526ms, DOMContentLoaded at 685ms, but the recommendations requests did
       not leave until 941ms and cards landed at 1425ms — the gap was almost entirely
       waiting on a /cart.js that was itself queued behind three other identical calls
       (durations to 539ms) and storepass.js parsing.
       The cart is only needed to (a) skip products already in the basket and (b) seed the
       tier-2 fallback — neither gates the FETCH. Both promises are started here on the
       same tick; skip[] is still populated before the first take(), so exclusion
       behaviour is unchanged. */
    /* Muted: the shopper cleared this rail and has not opened a product since. Nothing
       is fetched, picked stays empty, render() hides the section. */
    var cartPromise = muted ? Promise.resolve(null) : cartInfo();
    var primaryPromise = muted ? Promise.resolve([]) : primary();

    Promise.all([cartPromise, primaryPromise])
      .then(function (results) {
        var cart = results[0];
        var list = results[1];
        if (cart && excludeCart) {
          (cart.items || []).forEach(function (i) { skip[i.product_id] = 1; });
        }
        var inCart = cart && cart.items && cart.items[0] && cart.items[0].product_id;
        return Promise.resolve().then(function () {
          if (muted) return true;
          if (take(list)) return true;
          if (strictSource) return true;
          if (!inCart) return false;
          /* tier 2 -- pairs with what is already in the cart */
          return recommend(inCart, limit * 2, 'complementary').then(function (l) {
            if (take(l)) return true;
            return recommend(inCart, limit * 2, 'related').then(take);
          });
        });
      })
      .then(function (full) {
        if (full || strictSource || picked.length >= limit) return;
        /* tier 3 -- merchant-chosen fallback collection */
        return fromCollection(fallbackHandle, Math.max(limit * 3, 12)).then(take);
      })
      .then(render)
      .catch(render);
  }

  function start() {
    var rails = document.querySelectorAll('[data-hv-rail]');
    for (var i = 0; i < rails.length; i++) {
      if (!rails[i].__hvFilled) { rails[i].__hvFilled = true; fill(rails[i]); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ==========================================================================
   Free-shipping meter — cart-change owner (2026-08-30, v7 cart reconcile).

   WHY THIS EXISTS. Before the v7 cart reconcile the meter was refreshed by
   cart-redesign.js: watchSubtotalForMeter() put a MutationObserver on
   .tc-checkout-price, and the 3.1.0 re-render rewrote that text on every cart
   change. The reconcile removed .tc-checkout-price (v7's cart-price.liquid +
   CartItems.build() own the subtotal now), which silently removed the only
   working trigger. cart-redesign.js's other observer — observeCart() on
   .cart__table — was MEASURED not to reach the meter: a real childList mutation
   of [data-items-holder] produced zero /cart.js reads. Do not rely on it.

   WHAT THIS DOES. Hangs off v7's own post-render event instead of diffing the
   DOM. CartItems.build() dispatches theme:cart:change as its last act after the
   cart HTML is in place, on EVERY mutation — add, quantity, remove, discount —
   from both the drawer and the cart page. One debounced /cart.js read is the
   single source of truth for the meter, so the bar can never disagree with the
   real cart.

   SINGLE OWNER. This is now the only meter refresher. cart-redesign.js's
   reconcileSubtotal() / watchSubtotalForMeter() are inert by design (their
   selector no longer exists) and must stay that way — v7 owns the subtotal.
   Do NOT "restore" .tc-checkout-price to bring them back; that reintroduces two
   writers for one number.

   MARKETS-AWARE THRESHOLD. The limit is 17500 cents CAD scaled by
   Shopify.currency.rate, because /cart.js totals are PRESENTMENT cents. Verified
   against the live delivery profile (2026-08-30): every free-shipping method
   condition on the store — the three Canada zones AND the US zone's "Standard
   International (4 to 8 Business Days)" — is TOTAL_PRICE >= 175.00 **CAD**.
   Shopify evaluates that condition in shop currency whatever the shopper sees,
   so the CAD-175 equivalent is the correct bar in every market.
   Comparing presentment cents to a bare 17500 (what this did before) understates
   progress for every non-CAD shopper: at rate 0.719 a USD cart of $130 is
   $180.75 CAD and already qualifies, but the old maths told them they were $45
   short. rate is "1.0" for CAD, so CAD traffic is bit-for-bit unchanged.
   ========================================================================== */
(function () {
  'use strict';

  var FREE_SHIP_CENTS_CAD = 17500;
  var timer = null;

  function limitInPresentmentCents() {
    var rate = 1;
    try {
      var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
      if (isFinite(r) && r > 0) rate = r;
    } catch (e) {}
    return FREE_SHIP_CENTS_CAD * rate;
  }

  function refreshMeter() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        /* parse-guarded, never content-type: the Noibu wrapper hides headers */
        var cart = null;
        try { cart = JSON.parse(text); } catch (e) { return; }
        if (!cart || typeof cart.total_price !== 'number') return;
        try {
          if (typeof window.calculateProgress === 'function') {
            window.calculateProgress(cart.total_price, limitInPresentmentCents());
          }
        } catch (e) {}
      })
      .catch(function () {});
  }

  /* short debounce so a burst of clicks collapses to one read */
  function scheduleMeter() { clearTimeout(timer); timer = setTimeout(refreshMeter, 120); }

  document.addEventListener('theme:cart:change', scheduleMeter);   /* v7 build() — every cart mutation */
  document.addEventListener('theme:product:added', scheduleMeter); /* v7 add path */
  document.addEventListener('cart:updated', scheduleMeter);        /* Order Protect widget */
  window.addEventListener('pageshow', scheduleMeter);              /* bfcache return from checkout */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleMeter);
  } else {
    scheduleMeter();
  }
})();

/* ==========================================================================
   SOCIAL PROOF BAR — count-up
   Owner: sections/hv-social-proof.liquid ([data-hv-count]).

   The element already contains its final, comma-formatted value when it is
   rendered, so crawlers, no-JS visitors and anyone with reduced motion enabled
   see the real figure. This only ever replaces that text temporarily.

   Fires on scroll into view rather than page load: the bar sits below the fold,
   and a count-up that finishes before it is on screen has animated nothing.
   ========================================================================== */
(function hvSocialCountUp() {
  var SEL = '[data-hv-count]';
  var DURATION = 1400;

  function reducedMotion() {
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) { return false; }
  }

  /* Match the grouping already in the markup rather than imposing a locale:
     if the merchant typed 35,000 we group; if they typed 35000 we do not.

     The number field is free text, so a merchant may well fold the suffix into it
     ("35,000+" rather than 35,000 with + in its own field) — that is the obvious
     thing to do in the editor. Split the trailing non-numeric part off and re-append
     it on every frame, otherwise the + disappears for the length of the animation
     and pops back at the end. */
  function formatter(original) {
    var m = String(original).match(/^([\d.,\s]*\d)(.*)$/);
    var numeric = m ? m[1] : String(original);
    var tail = m ? m[2] : '';
    var grouped = numeric.indexOf(',') > -1;
    return function (n) {
      var s = String(Math.round(n));
      if (grouped) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return s + tail;
    };
  }

  function run(el) {
    if (el.__hvCounted) return;
    el.__hvCounted = true;

    var target = parseInt(el.getAttribute('data-hv-count'), 10);
    if (!isFinite(target) || target <= 0) return;

    /* START VALUE (2026-09-03). Counting 3,500,000 from zero is a blur of digits
       for 1.4s; the number only becomes readable in the last few hundred thousand.
       The merchant can set the start per claim (data-hv-count-from); when they
       have not, anything in the millions starts 500,000 short so the visible run is
       3,000,000 → 3,500,000, while small figures still count from 0. */
    var from = parseInt(el.getAttribute('data-hv-count-from'), 10);
    if (!isFinite(from) || from < 0 || from >= target) {
      from = target >= 1000000 ? target - 500000 : 0;
    }

    /* A re-run while a previous pass is still ticking (fast rotation, or scroll
       into view landing on the same beat) must not leave two loops fighting over
       textContent. Cancel the old one; its `original` is the authored string, which
       the attribute below preserves so the new pass starts from truth. */
    if (el.__hvRaf) cancelAnimationFrame(el.__hvRaf);
    if (!el.__hvOriginal) el.__hvOriginal = el.textContent;
    var original = el.__hvOriginal;
    if (reducedMotion()) { el.textContent = original; return; }   /* leave the final value in place */

    var fmt = formatter(original);
    var start = null;

    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / DURATION);
      /* easeOutQuart — fast out of the gate, long settle, so the final digits
         are readable instead of blurring past. */
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = fmt(from + (target - from) * eased);
      if (p < 1) {
        el.__hvRaf = requestAnimationFrame(frame);
      } else {
        el.__hvRaf = null;
        el.textContent = original;             /* restore the authored string exactly */
      }
    }

    el.textContent = fmt(from);
    el.__hvRaf = requestAnimationFrame(frame);
  }

  /* MOBILE SWITCHER (2026-09-03): the bar's claims cross-fade in turn via the
     hvSocialSwitch--<id> keyframes in the section CSS. Each claim's animation wraps
     exactly when that claim begins to fade back in, and the browser reports that
     wrap as `animationiteration` on the claim — so that is the moment to count its
     numbers up again. The event bubbles, so one listener on the document serves every
     instance; the name check keeps the icon nudge/pulse/bob animations (also
     infinite, also on this section) from triggering it. Desktop never fires it: the
     switcher keyframes only apply under the mobile media query. Reduced motion
     removes the animation entirely, so nothing re-runs there either. */
  document.addEventListener('animationiteration', function (e) {
    if (String(e.animationName).indexOf('hvSocialSwitch') !== 0) return;
    if (document.hidden) return;
    var item = e.target;
    if (!item || !item.querySelectorAll) return;
    var counts = item.querySelectorAll(SEL);
    for (var i = 0; i < counts.length; i++) {
      counts[i].__hvCounted = false;
      run(counts[i]);
    }
  });

  function init() {
    var els = document.querySelectorAll(SEL);
    if (!els.length) return;

    if (typeof IntersectionObserver === 'undefined') {
      /* No IO: the authored value is already correct, so do nothing. */
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          run(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-scan when the section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector(SEL)) init();
  });
})();

/* =============================================================
   HV BUNDLE — "Frequently bought together"
   Added 2026-08-31. Renders for sections/hv-bundle.liquid.

   The anchor tile and any Search & Discovery picks are already SERVER-rendered by
   the section. This script only: (a) tops the row up from the Recommendations API
   when the metafield is short, (b) keeps the running total in step with the
   checkboxes, (c) performs the multi-add.

   ONE REQUEST, NOT N. /cart/add.js accepts an `items` array, and using it matters
   for more than speed: the max-per-order Validation Function evaluates the RESULTING
   cart, so N separate adds can pass individually and still leave a cart that one
   combined add would have rejected. One atomic mutation is the only way the check
   means the same thing the shopper was shown.

   That also makes failure all-or-nothing, and cart-wide: one limited item stops the
   whole bundle. The message says so, because "Unavailable" on a button next to four
   products does not tell anyone which one to untick.

   Goes through window.fetch on purpose, so the 422 handler, the cart popover and the
   cart-count owner above all fire exactly as they do for a normal add.
   ============================================================= */
(function () {
  if (window.__hvBundle) return;
  window.__hvBundle = true;

  var MONEY = function (cents) { return '$' + ((Number(cents) || 0) / 100).toFixed(2); };

  function attr(el, name, dflt) {
    var v = el.getAttribute(name);
    return v == null || v === '' ? dflt : v;
  }

  function tiles(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-hv-bd-item]'));
  }

  function recalc(root) {
    var total = 0, chosen = 0;
    tiles(root).forEach(function (t) {
      var ck = t.querySelector('.hv-bd__ck');
      var on = ck ? ck.checked : true;
      t.setAttribute('data-off', on ? 'false' : 'true');
      if (on) { total += Number(t.getAttribute('data-price')) || 0; chosen++; }
    });
    var out = root.querySelector('[data-hv-bd-total]');
    if (out) out.textContent = MONEY(total);
    var btn = root.querySelector('[data-hv-bd-add]');
    /* The anchor is always ticked and always counted, so "nothing selected" can
       only mean every add-on was unticked — at which point this is just a slower
       route to the button the shopper already has. */
    if (btn) btn.disabled = chosen < 2;
    return chosen;
  }

  function normalize(p) {
    if (!p || !p.id) return null;
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v) return null;
    /* Three feeds, three shapes. /recommendations and /products/<h>.js give cents
       and a featured_image URL; /collections/<h>/products.json gives a "24.95"
       string and image OBJECTS ({src}). Normalise both here so a tile never shows
       "$0.25" or a broken <img>. */
    var price = v.price;
    if (typeof price === 'string') price = Math.round(parseFloat(price) * 100) || 0;
    /* 2026-09-04: a $0 (contact-us) product cannot be part of a bundle add */
    if (!price) return null;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && typeof img === 'object') img = img.src || img.url || '';
    return {
      id: String(p.id), vid: String(v.id), price: price,
      title: p.title || '', handle: String(p.handle || '').toLowerCase(),
      /* `type` FIRST, and this is not belt-and-braces — it is the bug fix.
         /recommendations/products.json returns the product type as `type`, NOT
         `product_type` (which is what /products.json uses). Reading only
         product_type made this undefined on every item, so the exclude-types list
         never matched anything and "Bubble Wrapped" (type "Bubble Wrap") appeared
         inside a bundle with its $2.50 added to the total. Verified against the live
         API response: {"title":"Bubble Wrapped","type":"Bubble Wrap","handle":"gift-wrap"}. */
      type: String(p.type || p.product_type || '').trim().toLowerCase(),
      image: img,
      tags: Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map(function (t) { return t.trim(); })
    };
  }

  /* AFFINITY GATE (2026-09-04). /recommendations intent=related is popularity-
     weighted on this catalogue, not similarity-weighted: measured on the Summoner
     Wars starter set it returned six Pokémon sleeved packs and a toploader. An
     algorithmic pick must share at least one tag from the anchor's identity
     families (Brands_ / Set_ / Series_ by default) — the same families the smart
     collections are built on, so "related" here means "would sit in the same
     collection". Curated picks (Search & Discovery / metafield) are server-rendered
     and never pass through this. */
  function affinityOf(tags, prefixes) {
    var out = {};
    (tags || []).forEach(function (t) {
      for (var i = 0; i < prefixes.length; i++) {
        if (prefixes[i] && t.indexOf(prefixes[i]) === 0) { out[t.toLowerCase()] = 1; return; }
      }
    });
    return out;
  }

  /* RANKING (2026-09-04, Edmond: "ideally expansion sets for board games or similar
     vendor"). Within a tier, candidates are ordered before they are taken:
       +4  title overlap — the candidate's title carries the anchor's leading words
           ("Summoner Wars …" -> "Summoner Wars - Faction Deck"), or the two share
           two or more distinctive words. This is what surfaces expansions, faction
           decks, sleeves-for-this-set and the like without any curation.
       +2  a boost tag (default Format_Expansion) — an expansion of the same brand
           outranks another base game from the same brand.
       +1  per shared identity family (Brands_ / Set_ / Series_).
     The affinity gate still applies first; ranking only decides the order among
     candidates that already passed it. A strong title overlap also passes the gate
     on its own, so an expansion whose Brands_ tag is missing is not thrown away. */
  var STOP = { the: 1, and: 1, of: 1, for: 1, with: 1, set: 1, edition: 1, pack: 1, box: 1, game: 1, card: 1, cards: 1, tcg: 1, pre: 1, order: 1, 'pre-order': 1, vs: 1, 'vs.': 1, '-': 1, '&': 1, '2nd': 1, '1st': 1, new: 1 };
  function words(title) {
    return String(title || '').toLowerCase().replace(/\([^)]*\)/g, ' ').split(/[^a-z0-9'+-]+/)
      .filter(function (w) { return w.length > 2 && !STOP[w]; });
  }
  function titleOverlap(anchorWords, title) {
    if (!anchorWords.length) return 0;
    var t = ' ' + words(title).join(' ') + ' ';
    var lead = anchorWords.slice(0, 2).join(' ');
    if (lead && t.indexOf(' ' + lead + ' ') > -1) return 2;
    var n = 0;
    anchorWords.forEach(function (w) { if (t.indexOf(' ' + w + ' ') > -1) n++; });
    return n >= 2 ? 1 : 0;
  }

  /* Tier 5: same vendor, via predictive search (`vendor:"X"` with fields=vendor is an
     exact-field query; verified 2026-09-04 it returns only that vendor's products).
     Predictive results carry no variants, so the ranked shortlist is hydrated from
     /products/<handle>.js before it can be tiled. Runs only when the API tiers
     did not fill the bundle, so a normal PDP pays nothing for it. */
  function vendorProducts(vendor, limit) {
    if (!vendor) return Promise.resolve([]);
    var want = vendor.trim().toLowerCase();
    var q = 'vendor:"' + vendor.replace(/"/g, '') + '"';
    return fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
                 '&resources[type]=product&resources[limit]=' + limit +
                 '&resources[options][fields]=vendor&resources[options][unavailable_products]=hide',
                 { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (j) { return (((j || {}).resources || {}).results || {}).products || []; })
      .then(function (list) {
        return list.filter(function (p) { return String(p.vendor || '').trim().toLowerCase() === want; });
      })
      .catch(function () { return []; });
  }

  function hydrate(list) {
    return Promise.all(list.map(function (p) {
      if (p && p.variants && p.variants.length) return p;
      return fetch('/products/' + encodeURIComponent(p.handle) + '.js',
                   { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (full) { if (full && p.tags && !full.tags) full.tags = p.tags; return full; })
        .catch(function () { return null; });
    })).then(function (l) { return l.filter(Boolean); });
  }

  function collectionProducts(handle, limit) {
    if (!handle) return Promise.resolve([]);
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + limit,
                 { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return j.products || []; })
      .catch(function () { return []; });
  }

  function recommend(pid, intent, limit) {
    return fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) +
                 '&limit=' + limit + '&intent=' + intent,
                 { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return j.products || []; })
      .catch(function () { return []; });
  }

  function tileEl(p, root) {
    var t = document.createElement('div');
    t.className = 'hv-bd__tile';
    t.setAttribute('data-hv-bd-item', '');
    t.setAttribute('data-pid', p.id);
    t.setAttribute('data-vid', p.vid);
    t.setAttribute('data-price', p.price);

    var ck = document.createElement('input');
    ck.type = 'checkbox';
    ck.className = 'hv-bd__ck';
    ck.checked = true;
    ck.setAttribute('aria-label', 'Include ' + p.title);
    t.appendChild(ck);

    /* Image and title are links to the product. The tile is NOT wrapped in one
       anchor: it contains a checkbox, and a checkbox inside a link is unusable —
       every attempt to tick it navigates instead. Two separate links pointing at the
       same URL is the trade, so the image carries aria-hidden and tabindex="-1" to
       keep it out of the tab order and stop a screen reader announcing the same
       product twice. The title link is the real one. */
    var url = '/products/' + p.handle;

    var img = document.createElement('a');
    img.className = 'hv-bd__img';
    img.href = url;
    img.setAttribute('aria-hidden', 'true');
    img.setAttribute('tabindex', '-1');
    if (p.image) {
      var i = document.createElement('img');
      i.src = p.image;
      i.alt = '';           /* the title link below is the accessible label */
      i.loading = 'lazy';
      i.decoding = 'async';
      img.appendChild(i);
    }
    t.appendChild(img);

    var n = document.createElement('a');
    n.className = 'hv-bd__name';
    n.href = url;
    n.textContent = p.title;
    t.appendChild(n);

    var pr = document.createElement('span');
    pr.className = 'hv-bd__price';
    pr.textContent = MONEY(p.price);
    t.appendChild(pr);

    ck.addEventListener('change', function () { recalc(root); });
    return t;
  }

  function fill(root) {
    var max = parseInt(attr(root, 'data-max-items', '2'), 10) || 2;
    var anchorId = attr(root, 'data-anchor-id', '');
    var cartIds = attr(root, 'data-cart-ids', ',');
    var denyTypes = attr(root, 'data-exclude-types', '').split(',')
      .map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    var denyHandles = attr(root, 'data-exclude-handles', '').split(',')
      .map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    var useComp = attr(root, 'data-use-complementary', 'true') !== 'false';
    var useRel = attr(root, 'data-use-related', 'true') !== 'false';
    var requireAffinity = attr(root, 'data-require-affinity', 'true') !== 'false';
    var prefixes = attr(root, 'data-affinity-prefixes', 'Brands_,Set_,Series_').split(',')
      .map(function (s) { return s.trim(); }).filter(Boolean);
    var anchorAffinity = affinityOf(attr(root, 'data-anchor-affinity', '').split('|'), prefixes);
    var anchorHasAffinity = Object.keys(anchorAffinity).length > 0;
    /* 2026-09-06 QA: same-department gate. Brands_ affinity alone let a Marvel Legendary
       expansion (Upper Deck) bundle with a Vs. System deck and a PWHL hockey box. When
       the anchor carries Categories_ tags, an algorithmic pick must share one. */
    var anchorCats = attr(root, 'data-anchor-cats', '').split('|')
      .map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    var fallbackCollection = attr(root, 'data-fallback-collection', '');
    var anchorVendor = attr(root, 'data-anchor-vendor', '');
    var useVendor = attr(root, 'data-use-vendor', 'true') !== 'false';
    var anchorWords = words(attr(root, 'data-anchor-title', ''));
    var boostTags = attr(root, 'data-boost-tags', 'Format_Expansion').split(',')
      .map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);

    var chain = root.querySelector('[data-hv-bd-chain]');
    var have = tiles(root).filter(function (t) { return t.getAttribute('data-anchor') !== 'true'; });
    var seen = {};
    seen[anchorId] = 1;
    have.forEach(function (t) { seen[t.getAttribute('data-pid')] = 1; });

    function score(p) {
      var s = 0, mine = affinityOf(p.tags, prefixes), shared = 0;
      for (var k in mine) { if (anchorAffinity[k]) shared++; }
      s += Math.min(shared, 2);
      var ov = titleOverlap(anchorWords, p.title);
      s += ov * 2;
      var lower = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
      for (var i = 0; i < boostTags.length; i++) { if (lower.indexOf(boostTags[i]) > -1) { s += 2; break; } }
      return { s: s, shared: shared, overlap: ov };
    }

    function take(list) {
      var ranked = [];
      list.forEach(function (raw, idx) {
        var p = normalize(raw);
        if (!p || seen[p.id]) return;
        if (cartIds.indexOf(',' + p.id + ',') > -1) return;
        /* 2026-09-09: $0 "Contact Us" SKUs (contact template, CONTINUE policy)
           are availableForSale and carry an EMPTY product_type, so neither the
           availability check nor denyTypes stops them. hv-cp's accept() already
           gates on price; hv-bd did not, which is how one reached the bundle. */
        if (!(parseFloat(p.price) > 0)) return;
        if (denyTypes.length && p.type && denyTypes.indexOf(p.type) > -1) return;
        if (denyHandles.length && denyHandles.indexOf(p.handle) > -1) return;
        if (anchorCats.length) {
          var pc = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
          var sameDept = anchorCats.some(function (c) { return pc.indexOf(c) > -1; });
          if (!sameDept) return;
        }
        var sc = score(p);
        /* An anchor with no identity tags at all (rare, untagged product) cannot be
           matched against, so the gate stands down rather than emptying the bundle. */
        if (requireAffinity && anchorHasAffinity && !sc.shared && sc.overlap < 2) return;
        ranked.push({ p: p, s: sc.s, idx: idx });
      });
      ranked.sort(function (a, b) { return b.s - a.s || a.idx - b.idx; });
      ranked.forEach(function (r) {
        if (have.length >= max || seen[r.p.id]) return;
        seen[r.p.id] = 1;
        var el = tileEl(r.p, root);
        chain.appendChild(el);
        have.push(el);
      });
      return have.length >= max;
    }

    function finish() {
      /* Only worth showing if there is at least ONE add-on. A "bundle" of the
         product you are already looking at is not a bundle. */
      if (have.length > 0) root.removeAttribute('hidden');
      /* 2026-09-05: the companions card (below) may reveal the section on its own;
         an empty bundle (anchor only) must not show beside it. */
      root.setAttribute('data-hv-bd-empty', have.length > 0 ? 'false' : 'true');
      if (have.length === 0) {
        var body = root.querySelector('.hv-bd__body'), head = root.querySelector('.hv-bd__head');
        if (body) body.hidden = true;
        if (head) head.hidden = true; /* the companions card carries its own heading */
      }
      recalc(root);
      wireAdd(root);
    }

    if (have.length >= max || !anchorId) { finish(); return; }

    var jobs = [];
    if (useComp) jobs.push(recommend(anchorId, 'complementary', max * 3));
    if (useRel) jobs.push(recommend(anchorId, 'related', max * 3));
    /* Tiers 5-6 — same vendor, then the anchor's own collection — only run when the
       API tiers left the bundle short (after the affinity gate they usually do for
       anything that is not Pokémon). Predictive results are ranked first and only
       the shortlist is hydrated, so this is one search call plus at most `max`
       product fetches. */
    function fallbacks() {
      if (have.length >= max) return Promise.resolve();
      var later = [];
      if (useVendor && anchorVendor) {
        later.push(vendorProducts(anchorVendor, 10).then(function (list) {
          var ranked = list.filter(function (p) { return p && !seen[String(p.id)]; })
            .map(function (p, idx) { return { p: p, s: score({ tags: p.tags, title: p.title }).s, idx: idx }; })
            .sort(function (a, b) { return b.s - a.s || a.idx - b.idx; })
            .slice(0, Math.max(max, 2))
            .map(function (r) { return r.p; });
          return hydrate(ranked);
        }));
      } else {
        later.push(Promise.resolve([]));
      }
      later.push(fallbackCollection ? collectionProducts(fallbackCollection, 24) : Promise.resolve([]));
      return Promise.all(later).then(function (results) {
        for (var i = 0; i < results.length; i++) { if (take(results[i])) break; }
      });
    }

    if (!jobs.length) { fallbacks().then(finish, finish); return; }

    /* Both API requests leave on the same tick rather than chaining complementary ->
       related, which cost ~700ms of serial waiting on the rails before it was fixed
       there. Order of preference is preserved by taking them in order afterwards. */
    Promise.all(jobs).then(function (results) {
      for (var i = 0; i < results.length; i++) { if (take(results[i])) break; }
      return fallbacks();
    }).then(finish, finish);
  }

  function wireAdd(root) {
    var btn = root.querySelector('[data-hv-bd-add]');
    var msg = root.querySelector('[data-hv-bd-msg]');
    if (!btn || btn.__hvWired) return;
    btn.__hvWired = true;

    btn.addEventListener('click', function () {
      var items = tiles(root).filter(function (t) {
        var ck = t.querySelector('.hv-bd__ck');
        if (ck && !ck.checked) return false;
        /* Never post an unavailable variant. The section already hides itself when
           the anchor is sold out, but that is a SETTING and can be switched off —
           and this add is ONE atomic request, so a single unbuyable line 422s the
           whole thing and the shopper is refused for products that were in stock.
           Liquid renders a tile for a sold-out product regardless, because
           selected_or_first_available_variant falls back to the first variant when
           none are available, so the tile looks normal and only the add fails. */
        /* 2026-09-09: data-available is 'true' for a $0 Contact Us SKU, so the
           availability guard alone let it post through this atomic add and
           bypass the PDP's Contact Us gate. Every tile carries data-price. */
        if (!(parseFloat(t.getAttribute('data-price')) > 0)) return false;
        return t.getAttribute('data-available') !== 'false';
      }).map(function (t) {
        return { id: Number(t.getAttribute('data-vid')), quantity: 1 };
      });
      if (!items.length) return;

      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = attr(root, 'data-adding-label', 'Adding…');
      if (msg) msg.textContent = '';

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.text().then(function (t) { return { ok: r.ok, t: t }; }); })
        .then(function (res) {
          if (res.ok) {
            btn.textContent = attr(root, 'data-added-label', 'Added to cart');
          } else {
            /* Parse-based, never content-type: the Noibu wrapper hides headers. */
            var reason = '';
            try { reason = (JSON.parse(res.t) || {}).description || ''; } catch (e) {}
            btn.textContent = original;
            if (msg) {
              msg.textContent = reason
                ? attr(root, 'data-limit-label', 'One of these is limited per order.')
                : 'That could not be added. Please try again.';
            }
          }
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
        })
        .catch(function () {
          btn.textContent = original;
          btn.disabled = false;
          if (msg) msg.textContent = 'That could not be added. Please try again.';
        });
    });
  }

  function start() {
    var roots = document.querySelectorAll('[data-hv-bundle]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].__hvBdInit) {
        roots[i].__hvBdInit = true;
        /* companions-only section (e.g. singles): no bundle to build, the companions
           resolver reveals the section on its own */
        if (roots[i].getAttribute('data-hv-bd-off') === 'true') { roots[i].setAttribute('data-hv-bd-empty', 'true'); continue; }
        fill(roots[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ---- PDP $0 products: Contact Us toggle + Notify Me scroll (2026-09-04) ----
   Markup comes from snippets/buy-buttons.liquid. The toggle reuses live's
   #author_bio_wrap ids so hv-theme.css styles it; the label flips to "Close"
   while the box is open (matches live). Notify Me scrolls to and focuses the
   back-in-stock form that stock v7 renders in .product-soldout-notification. */
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('#author_bio_wrap_toggle, [data-hv-notify-cta]');
    if (!t) return;
    if (t.id === 'author_bio_wrap_toggle') {
      var box = document.getElementById('author_bio_wrap');
      if (!box) return;
      var open = box.hidden;
      box.hidden = !open;
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!t.dataset.label) t.dataset.label = t.textContent;
      t.textContent = open ? 'Close' : t.dataset.label;
      return;
    }
    var form = document.querySelector('.product-soldout-notification');
    if (!form) return;
    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var field = form.querySelector('input[type="email"], input:not([type="hidden"]), button');
    if (field) setTimeout(function () { try { field.focus({ preventScroll: true }); } catch (err) { field.focus(); } }, 350);
  });
})();

/* ---- Companions card (2026-09-05) ------------------------------------------
   Renders for the <aside data-hv-bd-side> inside sections/hv-bundle.liquid.
   Rules come from the section's Rule blocks as JSON; each rule applies to a set
   of product types and lists storefront-search queries (with {series} {brand}
   {vendor} {title} placeholders) that run in order until the limit is filled.
   Storefront search accepts tag:/product_type:/vendor: prefixes — verified live
   2026-09-05. Picks: available, priced, not the anchor, not in cart, not on the
   deny lists, no duplicates; "require_shared" keeps only picks whose title starts
   with the anchor's series name or that carry the anchor's Brands_ tag. Adds go
   through /cart/add.js from a control carrying data-add-to-cart, so the cart
   popover and badge behave exactly as for every other add on the site. */
(function () {
  function money(v) {
    var n = typeof v === 'number' ? v : parseFloat(String(v || '0').replace(/[^0-9.]/g, ''));
    if (!isFinite(n)) return '';
    return '$' + n.toFixed(2);
  }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function fill(q, ctx) {
    return q.replace(/\{series\}/g, ctx.series).replace(/\{brand\}/g, ctx.brand)
            .replace(/\{brandname\}/g, ctx.brandName)
            .replace(/\{vendor\}/g, ctx.vendor).replace(/\{title\}/g, ctx.title).replace(/\s+/g, ' ').trim();
  }
  /* a "sleeves" query must return sleeves — storefront search also matches "Sleeved
     Booster Pack" and sleeve BUNDLES; those are products, not supplies */
  function offTopic(q, p) {
    if (!/sleeve/i.test(q)) return false;
    var t = String(p.title || '');
    if (/^single$/i.test(String(p.type || p.product_type || ''))) return true; /* a CARD called "Sleeves" (FaB: Quelling Sleeves) */
    return !/sleeve/i.test(t) || /sleeved|booster|blister|\bpack\b|\bbox\b|bundle|tin\b|collection|\(\w{2,4}\d{2,3}\)/i.test(t);
  }
  function search(q, limit) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=' + limit +
      '&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,vendor,tag';
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return (j && j.resources && j.resources.results && j.resources.results.products) || []; })
      .catch(function () { return []; });
  }
  function init(side) {
    if (!side || side.hasAttribute('data-hv-cp-init')) return;
    side.setAttribute('data-hv-cp-init', '1');
    var rulesEl = side.querySelector('[data-hv-cp-rules]');
    var rules = [];
    try { rules = JSON.parse(rulesEl.textContent || '[]'); } catch (e) { return; }
    var attr = function (n, d) { var v = side.getAttribute(n); return v == null ? d : v; };
    var ctx = {
      id: attr('data-anchor-id', ''), type: attr('data-anchor-type', '').trim().toLowerCase(),
      title: attr('data-anchor-title', ''), series: attr('data-anchor-series', ''),
      brand: attr('data-anchor-brand', ''), brandName: attr('data-anchor-brand', '').replace(/^Brands?[_:]/i, '').trim(), vendor: attr('data-anchor-vendor', ''),
      tags: attr('data-anchor-tags', '').split('|')
    };
    var cartIds = attr('data-cart-ids', ',');
    var denyTypes = attr('data-exclude-types', '').toLowerCase().split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    var denyHandles = attr('data-exclude-handles', '').toLowerCase().split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    var seriesLc = ctx.series.toLowerCase();
    var section = side.closest('[data-hv-bundle]');
    var list = side.querySelector('[data-hv-cp-list]');
    var titleEl = side.querySelector('[data-hv-cp-title]');

    /* A product's type lives in product.type OR in a Type_ tag (thousands of products
       have an empty product type and only the tag — e.g. Pitch Black Build & Battle:
       type "", tag Type_Booster Box). Match against both. */
    var anchorTypes = [ctx.type].concat(ctx.tags.filter(function (t) { return /^Type[_:]/i.test(t); })
      .map(function (t) { return t.replace(/^Type[_:]/i, '').trim().toLowerCase(); })).filter(Boolean);
    var matching = rules.filter(function (r) {
      var types = (r.types || []).map(function (t) { return String(t).trim(); }).filter(Boolean);
      if (types.length && !types.some(function (t) { return anchorTypes.indexOf(t) > -1; })) return false;
      if (r.tag_prefix && !ctx.tags.some(function (t) { return t.indexOf(r.tag_prefix) === 0; })) return false;
      return true;
    });
    if (!matching.length) return;

    function stem(t) {
      return String(t || '').toLowerCase().replace(/\([^)]*\)/g, '')
        .replace(/\b(pink|blue|gray|grey|black|white|red|green|yellow|purple|orange|clear|silver|gold|matte|gloss)\b/g, '')
        .replace(/[^a-z0-9]+/g, ' ').trim();
    }
    function accept(p, r, seen) {
      if (!p || !p.id || seen[p.id]) return false;
      /* colour / finish twins of a product already picked count as the same pick */
      var st = stem(p.title);
      if (st && seen['stem:' + st]) return false;
      seen['stem:' + st] = 1;
      if (String(p.id) === String(ctx.id)) return false;
      if (p.available === false) return false;
      if (!(parseFloat(p.price) > 0)) return false;
      if (cartIds.indexOf(',' + p.id + ',') > -1) return false;
      var t = String(p.type || p.product_type || '').trim().toLowerCase();
      if (denyTypes.length && t && denyTypes.indexOf(t) > -1) return false;
      if (denyHandles.length && denyHandles.indexOf(String(p.handle || '').toLowerCase()) > -1) return false;
      if (r.require_shared) {
        var shares = false;
        if (seriesLc && String(p.title || '').toLowerCase().indexOf(seriesLc) === 0) shares = true;
        if (!shares && ctx.brand && (p.tags || []).indexOf(ctx.brand) > -1) shares = true;
        if (!shares) return false;
      }
      return true;
    }

    function runRule(idx) {
      if (idx >= matching.length) return Promise.resolve(null);
      var r = matching[idx], limit = Math.max(1, parseInt(r.limit, 10) || 3);
      /* "query|N" = take at most N picks from that query (e.g. one Dragon Shield, then
         penny sleeves + toploaders) so a single query cannot fill the card with twins */
      var queries = (r.queries || []).map(function (q) {
        var parts = String(q).split('|'); var cap = parseInt(parts[1], 10);
        return { q: fill(parts[0], ctx), cap: isFinite(cap) && cap > 0 ? cap : 99 };
      }).filter(function (x) { return x.q && !/^\s*(tag:|product_type:|vendor:)?\s*$/.test(x.q); });
      var picks = [], seen = {};
      function step(qi) {
        if (picks.length >= limit || qi >= queries.length) return Promise.resolve();
        var took = 0;
        return search(queries[qi].q, 8).then(function (res) {
          res.forEach(function (p) { if (picks.length < limit && took < queries[qi].cap && !offTopic(queries[qi].q, p) && accept(p, r, seen)) { seen[p.id] = 1; picks.push(p); took++; } });
          return step(qi + 1);
        });
      }
      return step(0).then(function () { return picks.length ? { rule: r, picks: picks } : runRule(idx + 1); });
    }

    function tile(p) {
      var t = el('div', 'hv-cp__tile');
      var a = el('a', 'hv-cp__img'); a.href = p.url; a.setAttribute('aria-hidden', 'true'); a.tabIndex = -1;
      if (p.image || p.featured_image) { var img = el('img'); img.src = p.image || p.featured_image; img.alt = ''; img.loading = 'lazy'; img.width = 80; img.height = 80; a.appendChild(img); }
      t.appendChild(a);
      var info = el('div', 'hv-cp__info');
      var n = el('a', 'hv-cp__name', p.title); n.href = p.url; info.appendChild(n);
      info.appendChild(el('span', 'hv-cp__price', money(p.price)));
      t.appendChild(info);
      var vid = (p.variants && p.variants[0] && p.variants[0].id) || p.variant_id || null;
      var CART = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false"><path d="M1.5 2h2.2l1.1 9.2a1.3 1.3 0 0 0 1.3 1.15h8.1a1.3 1.3 0 0 0 1.28-1.06l1.02-5.4H4.6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" fill="none"/><circle cx="7.4" cy="16.2" r="1.5" fill="currentColor"/><circle cx="14.2" cy="16.2" r="1.5" fill="currentColor"/></svg>';
      var CHECK = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="m3 8.4 3.2 3.2L13 4.8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';
      var label = attr('data-add-label', 'Add') + ' — ' + (p.title || '');
      var btn = el('button', 'hv-cp__add'); btn.type = 'button'; btn.innerHTML = CART;
      btn.setAttribute('data-add-to-cart', ''); btn.setAttribute('aria-label', label); btn.title = attr('data-add-label', 'Add');
      var msg = el('span', 'hv-cp__msg'); msg.setAttribute('role', 'status'); msg.setAttribute('aria-live', 'polite'); msg.hidden = true;
      info.appendChild(msg);
      btn.addEventListener('click', function () {
        if (!(parseFloat(p.price) > 0)) { window.location.href = p.url; return; }
        if (!vid) { window.location.href = p.url; return; }
        btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (x) {
            if (x.ok) { btn.innerHTML = CHECK; btn.classList.add('hv-cp__add--added'); msg.textContent = attr('data-added-label', 'Added'); }
            else { msg.textContent = (x.j && (x.j.description || x.j.message)) || 'Unavailable'; msg.hidden = false; }
            setTimeout(function () { btn.innerHTML = CART; btn.classList.remove('hv-cp__add--added'); btn.disabled = false; if (x.ok) msg.textContent = ''; msg.hidden = true; }, 1800);
          })
          .catch(function () { btn.disabled = false; });
      });
      t.appendChild(btn);
      return t;
    }

    runRule(0).then(function (res) {
      if (!res) return;
      titleEl.textContent = res.rule.heading || '';
      /* search/suggest returns no variant id; fetch it for the add button (one request per pick, parallel) */
      return Promise.all(res.picks.map(function (p) {
        return fetch('/products/' + p.handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; })
          .then(function (full) { if (full) { p.variants = full.variants; p.featured_image = p.featured_image || full.featured_image; } return p; })
          .catch(function () { return p; });
      })).then(function (picks) {
        picks.forEach(function (p) { list.appendChild(tile(p)); });
        side.hidden = false;
        if (section) section.removeAttribute('hidden');
      });
    });
  }
  function boot() { document.querySelectorAll('[data-hv-bd-side]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* ---- TCG singles ticker: phone behaviours (2026-09-05) ------------------------
   1. TAP TO EXPAND: on coarse-pointer screens the brand block toggles
      .hv-singles--expanded (CSS in the section grows the strip ~50%). The block is
      a link to the collection on desktop; on phones the tap is the toggle and the
      collection link is the "View singles" row that appears when expanded.
   2. SWIPE TO SCRUB: the CSS marquee is replaced by a JS ticker on touch screens.
      It advances at the section's own speed (track width / cycle seconds), a thumb
      drag scrubs it 1:1, and release keeps the fling velocity with decay before
      easing back to the base speed. Loops by wrapping at half the marquee width
      (the clone). A drag longer than 8px swallows the click so a scrub never
      navigates. Vertical page scrolling is untouched (touch-action: pan-y). */
(function () {
  var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  if (!coarse) return;
  function init(sec) {
    if (sec.hasAttribute('data-hv-singles-init')) return;
    sec.setAttribute('data-hv-singles-init', '1');
    var brand = sec.querySelector('.hv-singles__brand');
    var chev = sec.querySelector('.hv-singles__chev');
    if (brand) {
      if (chev) chev.hidden = false;
      brand.setAttribute('role', 'button');
      brand.setAttribute('aria-expanded', 'false');
      brand.addEventListener('click', function (e) {
        if (!window.matchMedia('(max-width: 767px)').matches) return;
        e.preventDefault();
        var on = !sec.classList.contains('hv-singles--expanded');
        sec.classList.toggle('hv-singles--expanded', on);
        brand.setAttribute('aria-expanded', on ? 'true' : 'false');
        measure();
      });
    }
    var list = sec.querySelector('.hv-singles__list');
    var marquee = sec.querySelector('.hv-singles__marquee');
    if (!list || !marquee || sec.getAttribute('data-cycle') !== 'true') return;
    /* the CSS marquee stays on until the JS loop has actually ticked once, so a
       webview that throttles rAF never ends up with a frozen strip */
    var half = 0, offset = 0, base = 0, vel = 0, dragging = false, lastX = 0, lastT = 0, startX = 0, moved = 0, last = 0, armed = false;
    function measure() {
      half = marquee.scrollWidth / 2;
      var secs = parseFloat(sec.getAttribute('data-cycle-speed')) || 120;
      base = half > 0 ? half / secs : 0; /* px per second, same pace as the CSS ticker */
    }
    function apply() {
      if (half > 0) { offset = ((offset % half) + half) % half; }
      marquee.style.transform = 'translate3d(' + (-offset) + 'px,0,0)';
    }
    function frame(t) {
      if (!armed) { armed = true; list.setAttribute('data-hv-touch', '1'); measure(); }
      var dt = last ? Math.min(0.05, (t - last) / 1000) : 0;
      last = t;
      if (!dragging) {
        if (Math.abs(vel) > 1) { offset += vel * dt; vel *= Math.pow(0.08, dt); if (Math.abs(vel) < base) vel = 0; }
        else offset += base * dt;
        apply();
      }
      requestAnimationFrame(frame);
    }
    list.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      dragging = true; moved = 0; startX = lastX = e.clientX; lastT = performance.now(); vel = 0;
    }, { passive: true });
    list.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var now = performance.now(), dx = e.clientX - lastX, dt = Math.max(1, now - lastT) / 1000;
      lastX = e.clientX; lastT = now; moved = Math.max(moved, Math.abs(e.clientX - startX));
      offset -= dx; vel = -dx / dt; apply();
    }, { passive: true });
    function end() {
      if (!dragging) return;
      dragging = false; last = 0;
      /* keep the fling; a slow release just resumes the base speed forward */
      if (Math.abs(vel) < 60) vel = 0;
    }
    list.addEventListener('pointerup', end, { passive: true });
    list.addEventListener('pointercancel', end, { passive: true });
    list.addEventListener('click', function (e) { if (moved > 8) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    measure();
    window.addEventListener('resize', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    requestAnimationFrame(frame);
  }
  function boot() { document.querySelectorAll('[data-hv-singles]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* ---- PDP gallery swipe bar, phones (2026-09-05) ------------------------------
   The scroller (.product__images__scroller) is a native horizontal scroll-snap
   list on phones. This sizes the theme's own .custom-scrollbar track to the
   visible fraction and moves it with scrollLeft; it only shows when the gallery
   actually overflows (2+ images). Uses the CSS variables theme.css already reads. */
(function () {
  function init(bar) {
    if (bar.hasAttribute('data-hv-bar-init')) return;
    bar.setAttribute('data-hv-bar-init', '1');
    var scroller = bar.previousElementSibling;
    while (scroller && !scroller.classList.contains('product__images__scroller')) scroller = scroller.previousElementSibling;
    if (!scroller) return;
    var track = bar.querySelector('[data-custom-scrollbar-track]');
    var raf = 0;
    /* 2026-09-05 (later): desktop swipes too (hv-theme.css "PDP desktop gallery"), so
       the bar is width-agnostic now, and the two hover arrows step one frame. */
    var container = scroller.parentElement;
    var prev = container && container.querySelector('[data-hv-gallery-prev]');
    var next = container && container.querySelector('[data-hv-gallery-next]');
    function step(dir) {
      var cw = scroller.clientWidth;
      var target = Math.round(scroller.scrollLeft / cw) + dir;
      scroller.scrollTo({ left: target * cw, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    function update() {
      raf = 0;
      var sw = scroller.scrollWidth, cw = scroller.clientWidth;
      if (sw <= cw + 2) {
        bar.removeAttribute('data-hv-ready');
        if (prev) prev.removeAttribute('data-hv-ready');
        if (next) next.removeAttribute('data-hv-ready');
        return;
      }
      bar.setAttribute('data-hv-ready', '1');
      if (prev) { prev.setAttribute('data-hv-ready', '1'); prev.disabled = scroller.scrollLeft <= 2; }
      if (next) { next.setAttribute('data-hv-ready', '1'); next.disabled = scroller.scrollLeft >= sw - cw - 2; }
      var frac = cw / sw;
      var barW = bar.clientWidth || cw;
      var pos = (scroller.scrollLeft / sw) * barW;
      bar.style.setProperty('--track-width', (frac * 100).toFixed(2) + '%');
      if (track) track.style.setProperty('--position', pos.toFixed(1) + 'px');
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(update); }
    scroller.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(scroller);
    update();
  }
  function boot() { document.querySelectorAll('[data-hv-gallery-bar]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* ---- PDP quantity: never above max (2026-09-05) -------------------------------
   buy-buttons.liquid puts the sellable cap on the input's max (stock, or the
   per-order limit when lower). Stock v7's stepper already stops the + button at
   max; this clamps a TYPED value on change/blur so the form can't submit more
   than is available, and nudges the shopper with the theme's own limit toast if
   present. */
(function () {
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.tagName !== 'INPUT' || input.name !== 'quantity' || !input.max) return;
    if (!input.closest('.product-form__quantity, quantity-input')) return;
    var max = parseInt(input.max, 10), v = parseInt(input.value, 10);
    if (!isFinite(max) || !isFinite(v)) return;
    if (v > max) {
      input.value = max;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (input.hasAttribute('data-hv-stock-cap') && window.hvQtyToast) {
        try { window.hvQtyToast('Only ' + max + ' available.'); } catch (err) {}
      }
    }
  }, true);
})();


/* ---- Cart page repaint (2026-09-06 QA N1/N2) ----------------------------------
   3.1.0's theme.dev.js exposed window.cart.getCart(), which re-rendered the cart
   table after any mutation. v7 has no window.cart, so on /cart two paths went
   stale: (1) a rail "Add to cart" updated the badge but not the rows/subtotal
   (MEASURED: UI $24.95 vs cart.js $564.85, empty cart kept saying "Your cart is
   empty"); (2) back from checkout, the Order Protect strip removed the fee line
   server-side but the row, badge and subtotal stayed (MEASURED: 4 rows / $238.59
   vs 3 lines / $230.60).

   The cart-count owner above already syncs after EVERY mutation (fetch/XHR
   interception + bfcache pageshow) and emits hv:cart-count. On the cart template
   this listener compares the rendered rows (input#updates_<line.key>) with
   cart.js and reloads once when they differ — the same full-page refresh the
   quantity inputs already do here, so nothing new to re-bind. Never touches fee
   lines (single-owner rule); it only re-reads. Guards: cart template only,
   visible tab, one reload per 8s (a mismatch that survives a reload — e.g. a
   line the theme deliberately hides — must not loop). */
(function () {
  if (!document.body || !document.body.classList.contains('template-cart')) return;
  var KEY = 'hv_cart_repaint_at';
  var checking = false;

  function renderedLines() {
    var map = {};
    var inputs = document.querySelectorAll('.cart__table-row input[name="updates[]"]');
    for (var i = 0; i < inputs.length; i++) {
      var id = inputs[i].id || '';
      if (id.indexOf('updates_') !== 0) continue;
      map[id.slice(8)] = parseInt(inputs[i].value, 10) || 0;
    }
    return map;
  }

  function differs(cart) {
    var ui = renderedLines();
    var items = (cart && cart.items) || [];
    if (items.length !== Object.keys(ui).length) return true;
    for (var i = 0; i < items.length; i++) {
      var k = items[i].key;
      if (!(k in ui)) return true;
      if (ui[k] !== items[i].quantity) return true;
    }
    return false;
  }

  function reloadOnce() {
    var last = 0;
    try { last = parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (e) {}
    if (Date.now() - last < 8000) return;
    try { sessionStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    /* let a rail button finish its "Added" state before the page goes */
    setTimeout(function () { window.location.reload(); }, 600);
  }

  function check() {
    if (checking || document.visibilityState === 'hidden') return;
    checking = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) {
        var j = null;
        try { j = t && JSON.parse(t); } catch (e) {}
        if (j && j.items && differs(j)) reloadOnce();
      })
      .catch(function () {})
      .then(function () { checking = false; });
  }

  function renderedUnits() {
    var ui = renderedLines(), n = 0;
    for (var k in ui) n += ui[k];
    return n;
  }

  /* Cheap pre-check first: the event carries item_count, the rows carry their
     quantities. Only when those disagree is cart.js read for the exact key/qty
     compare (keeps the /cart.js GET count where the Sep 6 review left it). */
  document.addEventListener('hv:cart-count', function (e) {
    var n = e && e.detail && e.detail.count;
    if (typeof n !== 'number' || n === renderedUnits()) return;
    check();
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) setTimeout(check, 900);
  });
  /* check() deliberately does nothing while the tab is hidden — reloading a
     background tab under someone is worse than a stale total. This re-checks the
     moment they come back, so a mutation that happened in another tab (or while
     this one was backgrounded) is repaired on return instead of never. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') setTimeout(check, 200);
  });
})();

/* build: 2026-09-06T22:55Z — cart repaint + visibilitychange re-check */

/* ---------------------------------------------------------------------------
   2026-09-08 — OUT-OF-STOCK GUARD for the "Frequently bought together" section.

   RULE (Edmond): if the main PDP CTA says out of stock, the bundle must not
   offer "Add all to cart". Ideally the section is not there at all.

   WHY THIS EXISTS IN JS AND NOT ONLY IN LIQUID. hv-bundle.liquid already gates
   on `anchor.available` (hide_when_sold_out), and on a fresh render that gate
   demonstrably fires — verified 2026-09-08 on the sold-out 30th Celebration ETB
   three ways (rendered DOM, uncached fetch, cf-cache-status DYNAMIC) and again
   with a seeded cart. But that gate runs ONCE, at render. Any HTML that outlives
   the stock — Shopify's page cache, bfcache, back/forward, a pre-order tab left
   open while allocation ran out — keeps a fully live "Add all to cart" pointing
   at something nobody can buy. "Add all" posts ONE atomic /cart/add.js, so an
   unavailable anchor 422s the whole request and the shopper is refused for the
   in-stock items too (see the SOLD-OUT ANCHOR note in hv-bundle.liquid).

   The main CTA is the source of truth on purpose: it is the same signal the
   shopper is looking at, so the two can never visibly disagree again.

   COST. This does NOT observe anything. It writes ONE attribute — data-hv-oos —
   and a CSS rule in hv-bundle.liquid does the hiding. That attribute is
   deliberately not `hidden`: the bundle resolver owns `hidden` and removes it
   asynchronously once picks resolve, so hiding via `hidden` would be a tug-of-war
   needing a MutationObserver to win. Keyed off our own attribute there is nothing
   to fight and nothing to watch, so the steady-state cost is zero.

   Re-run only on events that can change the answer: pageshow (bfcache restores do
   not re-run Liquid) and variant changes.
   --------------------------------------------------------------------------- */
(function () {
  var OOS = /sold\s*out|out of stock|unavailable|notify me/i;

  /* The CTA must be the MAIN product form's, never a card's. Rails, the bundle
     tiles and the companions tiles all render their own add buttons, and a
     sold-out card would otherwise hide the bundle on an in-stock PDP. */
  function mainCta() {
    var scopes = ['.product__cta', '.product__info__wrapper', '.product__form-buttons'];
    for (var s = 0; s < scopes.length; s++) {
      var host = document.querySelector(scopes[s]);
      if (!host) continue;
      /* v7 renders `product-form__submit`; the v3 twin `product__form-submit`
         is kept only so this survives a rollback to the old theme. */
      var btn = host.querySelector('.product-form__submit, .product__form-submit, button[name="add"], input[name="add"]');
      if (btn) return btn;
    }
    /* Last resort: a cart form that is NOT inside any card-ish container. */
    var all = document.querySelectorAll('form[action*="/cart/add"] [name="add"]');
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest('[data-hv-bd-off], .hv-rail__card, .store-pass-product, .hv-cp')) return all[i];
    }
    return null;
  }

  function isSoldOut() {
    /* The theme stamps the CTA column with `variant--soldout`; trust it first. */
    if (document.querySelector('.product__info__wrapper.variant--soldout')) return true;
    var btn = mainCta();
    if (!btn) return null;                  /* unknown -> do nothing, never guess */
    if (btn.disabled) return true;
    return OOS.test(btn.textContent || btn.value || '');
  }

  function apply() {
    if (!document.body || document.body.className.indexOf('template-product') === -1) return;
    var roots = document.querySelectorAll('[data-hv-bd-off]');
    if (!roots.length) return;

    var oos = isSoldOut();
    if (oos === null) return;               /* couldn't identify the CTA: leave alone */

    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var section = root.closest ? root.closest('.shopify-section') : null;
      var add = root.querySelector('[data-hv-bd-add]');
      var marked = root.getAttribute('data-hv-oos') === 'true';

      if (oos === marked) continue;         /* already in the right state */

      if (oos) {
        /* One attribute write per node. The CSS in hv-bundle.liquid does the
           hiding, so the resolver's `hidden` juggling cannot undo it and there is
           nothing to observe. */
        root.setAttribute('data-hv-oos', 'true');
        if (section) section.setAttribute('data-hv-oos', 'true');
        /* Belt and braces: if the section is ever shown anyway, the button must
           tell the truth rather than 422 the shopper on the in-stock items. */
        if (add) {
          if (!add.hasAttribute('data-hv-label')) {
            add.setAttribute('data-hv-label', add.textContent || '');
          }
          add.disabled = true;
          add.textContent = 'Out of stock';
        }
      } else {
        /* Symmetric restore — a variant switched back into stock must not be left
           with a hidden section and a dead button. */
        root.removeAttribute('data-hv-oos');
        if (section) section.removeAttribute('data-hv-oos');
        if (add) {
          add.disabled = false;
          if (add.hasAttribute('data-hv-label')) {
            add.textContent = add.getAttribute('data-hv-label');
            add.removeAttribute('data-hv-label');
          }
        }
      }
    }
  }

  function boot() { apply(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* bfcache / back-forward: Liquid does not re-run, so re-assert on restore. */
  window.addEventListener('pageshow', apply);
  /* Variant switching re-renders the CTA. The theme's event name is not relied
     upon — several are bound, and the observer plus a short settle pass cover
     any we do not know about. */
  ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (evt) {
    document.addEventListener(evt, apply);
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.product__cta, .product__form-buttons')) {
      setTimeout(apply, 60);
    }
  });
})();
